const basicLightbox = {
    _toElement: function(i, e=!1) {
        const t = document.createElement("div");
        return t.innerHTML = i.trim(),
        e === !0 ? t.children : t.firstChild
    },
    _validateOptions: function(i={}) {
        return (i = Object.assign({}, i)).closable == null && (i.closable = !0),
        i.className == null && (i.className = ""),
        i.onShow == null && (i.onShow = ()=>{}
        ),
        i.onClose == null && (i.onClose = ()=>{}
        ),
        i.trigger == null && (i.trigger = !1),
        i.focus == null && (i.focus = !1),
        i
    },
    _validateContent: function(i) {
        const e = typeof i == "string"
          , t = i instanceof HTMLElement;
        if (e === !1 && t === !1)
            throw new Error("Content must be a DOM element/node or string");
        return e === !0 ? Array.from(this._toElement(i, !0)) : i.tagName === "TEMPLATE" ? [i.content.cloneNode(!0)] : Array.from(i.children)
    },
    _containsTag: function(i, e) {
        const t = i.children;
        return t.length === 1 && t[0].tagName === e
    },
    _render: function(i, e) {
        const t = this._toElement(`
      <div class="basicLightbox ${e.className}">
        <div class="basicLightbox__placeholder" role="dialog"></div>
      </div>
    `)
          , s = t.querySelector(".basicLightbox__placeholder");
        i.forEach(l=>s.appendChild(l));
        const r = this._containsTag(s, "IMG")
          , o = this._containsTag(s, "VIDEO")
          , n = this._containsTag(s, "IFRAME");
        return r === !0 && t.classList.add("basicLightbox--img"),
        o === !0 && t.classList.add("basicLightbox--video"),
        n === !0 && t.classList.add("basicLightbox--iframe"),
        t
    },
    _show: function(i, e) {
        return document.body.appendChild(i),
        setTimeout(()=>{
            requestAnimationFrame(()=>(i.classList.add("basicLightbox--visible"),
            e()))
        }
        , 10),
        !0
    },
    _close: function(i, e) {
        return i.classList.remove("basicLightbox--visible"),
        setTimeout(()=>(this._visible(i) === !1 || i.parentElement.removeChild(i),
        e()), 410),
        !0
    },
    _visible: function(i) {
        return (i = i || document.querySelector(".basicLightbox")) != null && i.ownerDocument.body.contains(i) === !0
    },
    create: function(i, e) {
        i = this._validateContent(i),
        e = this._validateOptions(e);
        const t = this._render(i, e)
          , s = (n,l)=>e.onShow(o) !== !1 && this._show(t, ()=>{
            if (typeof l == "string" && t.querySelectorAll(l) && t.querySelectorAll(l)[0].focus(),
            typeof n == "function")
                return n(o)
        }
        )
          , r = n=>e.onClose(o) !== !1 && this._close(t, ()=>{
            if (typeof n == "function")
                return n(o)
        }
        );
        e.closable === !0 && (t.addEventListener("click", n=>{
            n.target === t && r()
        }
        ),
        window.addEventListener("keydown", n=>{
            n.keyCode == 27 && r()
        }
        ),
        t.querySelector(".basicLightboxClose") && (t.querySelector(".basicLightboxClose").addEventListener("click", n=>{
            n.preventDefault(),
            r()
        }
        ),
        t.querySelector(".basicLightboxClose").addEventListener("keydown", n=>{
            n.keyCode == 13 && r()
        }
        ))),
        e.trigger && (e.trigger.addEventListener("click", n=>{
            n.preventDefault(),
            s(null, e.focus)
        }
        ),
        e.trigger.addEventListener("keydown", n=>{
            n.keyCode == 13 && s(null, e.focus)
        }
        ));
        const o = {
            element: ()=>t,
            visible: ()=>this._visible(t),
            show: s,
            close: r
        };
        return o
    }
};
(function() {
    "use strict";
    function i() {
        var e = window
          , t = document;
        if (!("scrollBehavior"in t.documentElement.style) || e.__forceSmoothScrollPolyfill__ === !0) {
            var s, r = e.HTMLElement || e.Element, o = 468, n = {
                scroll: e.scroll || e.scrollTo,
                scrollBy: e.scrollBy,
                elementScroll: r.prototype.scroll || d,
                scrollIntoView: r.prototype.scrollIntoView
            }, l = e.performance && e.performance.now ? e.performance.now.bind(e.performance) : Date.now, a = (s = e.navigator.userAgent,
            new RegExp(["MSIE ", "Trident/", "Edge/"].join("|")).test(s) ? 1 : 0);
            e.scroll = e.scrollTo = function() {
                arguments[0] !== void 0 && (h(arguments[0]) !== !0 ? v.call(e, t.body, arguments[0].left !== void 0 ? ~~arguments[0].left : e.scrollX || e.pageXOffset, arguments[0].top !== void 0 ? ~~arguments[0].top : e.scrollY || e.pageYOffset) : n.scroll.call(e, arguments[0].left !== void 0 ? arguments[0].left : typeof arguments[0] != "object" ? arguments[0] : e.scrollX || e.pageXOffset, arguments[0].top !== void 0 ? arguments[0].top : arguments[1] !== void 0 ? arguments[1] : e.scrollY || e.pageYOffset))
            }
            ,
            e.scrollBy = function() {
                arguments[0] !== void 0 && (h(arguments[0]) ? n.scrollBy.call(e, arguments[0].left !== void 0 ? arguments[0].left : typeof arguments[0] != "object" ? arguments[0] : 0, arguments[0].top !== void 0 ? arguments[0].top : arguments[1] !== void 0 ? arguments[1] : 0) : v.call(e, t.body, ~~arguments[0].left + (e.scrollX || e.pageXOffset), ~~arguments[0].top + (e.scrollY || e.pageYOffset)))
            }
            ,
            r.prototype.scroll = r.prototype.scrollTo = function() {
                if (arguments[0] !== void 0)
                    if (h(arguments[0]) !== !0) {
                        var c = arguments[0].left
                          , u = arguments[0].top;
                        v.call(this, this, c === void 0 ? this.scrollLeft : ~~c, u === void 0 ? this.scrollTop : ~~u)
                    } else {
                        if (typeof arguments[0] == "number" && arguments[1] === void 0)
                            throw new SyntaxError("Value could not be converted");
                        n.elementScroll.call(this, arguments[0].left !== void 0 ? ~~arguments[0].left : typeof arguments[0] != "object" ? ~~arguments[0] : this.scrollLeft, arguments[0].top !== void 0 ? ~~arguments[0].top : arguments[1] !== void 0 ? ~~arguments[1] : this.scrollTop)
                    }
            }
            ,
            r.prototype.scrollBy = function() {
                arguments[0] !== void 0 && (h(arguments[0]) !== !0 ? this.scroll({
                    left: ~~arguments[0].left + this.scrollLeft,
                    top: ~~arguments[0].top + this.scrollTop,
                    behavior: arguments[0].behavior
                }) : n.elementScroll.call(this, arguments[0].left !== void 0 ? ~~arguments[0].left + this.scrollLeft : ~~arguments[0] + this.scrollLeft, arguments[0].top !== void 0 ? ~~arguments[0].top + this.scrollTop : ~~arguments[1] + this.scrollTop))
            }
            ,
            r.prototype.scrollIntoView = function() {
                if (h(arguments[0]) !== !0) {
                    var c = function(m) {
                        for (; m !== t.body && (y = g(A = m, "Y") && S(A, "Y"),
                        b = g(A, "X") && S(A, "X"),
                        (y || b) === !1); )
                            m = m.parentNode || m.host;
                        var A, y, b;
                        return m
                    }(this)
                      , u = c.getBoundingClientRect()
                      , p = this.getBoundingClientRect();
                    c !== t.body ? (v.call(this, c, c.scrollLeft + p.left - u.left, c.scrollTop + p.top - u.top),
                    e.getComputedStyle(c).position !== "fixed" && e.scrollBy({
                        left: u.left,
                        top: u.top,
                        behavior: "smooth"
                    })) : e.scrollBy({
                        left: p.left,
                        top: p.top,
                        behavior: "smooth"
                    })
                } else
                    n.scrollIntoView.call(this, arguments[0] === void 0 || arguments[0])
            }
        }
        function d(c, u) {
            this.scrollLeft = c,
            this.scrollTop = u
        }
        function h(c) {
            if (c === null || typeof c != "object" || c.behavior === void 0 || c.behavior === "auto" || c.behavior === "instant")
                return !0;
            if (typeof c == "object" && c.behavior === "smooth")
                return !1;
            throw new TypeError("behavior member of ScrollOptions " + c.behavior + " is not a valid value for enumeration ScrollBehavior.")
        }
        function g(c, u) {
            return u === "Y" ? c.clientHeight + a < c.scrollHeight : u === "X" ? c.clientWidth + a < c.scrollWidth : void 0
        }
        function S(c, u) {
            var p = e.getComputedStyle(c, null)["overflow" + u];
            return p === "auto" || p === "scroll"
        }
        function f(c) {
            var u, p, m, A, y = (l() - c.startTime) / o;
            A = y = y > 1 ? 1 : y,
            u = .5 * (1 - Math.cos(Math.PI * A)),
            p = c.startX + (c.x - c.startX) * u,
            m = c.startY + (c.y - c.startY) * u,
            c.method.call(c.scrollable, p, m),
            p === c.x && m === c.y || e.requestAnimationFrame(f.bind(e, c))
        }
        function v(c, u, p) {
            var m, A, y, b, L = l();
            c === t.body ? (m = e,
            A = e.scrollX || e.pageXOffset,
            y = e.scrollY || e.pageYOffset,
            b = n.scroll) : (m = c,
            A = c.scrollLeft,
            y = c.scrollTop,
            b = d),
            f({
                scrollable: m,
                method: b,
                startTime: L,
                startX: A,
                startY: y,
                x: u,
                y: p
            })
        }
    }
    typeof exports == "object" && typeof module != "undefined" ? module.exports = {
        polyfill: i
    } : i()
}
)();
class AnnouncementBar extends HTMLElement {
    constructor() {
        super(),
        document.querySelector(".announcement__exit") && document.querySelector(".announcement__exit").addEventListener("click", ()=>{
            document.body.classList.add("no-transition"),
            setTimeout(()=>{
                document.body.classList.remove("show-announcement-bar"),
                localStorage.setItem("announcement-dismissed", "true"),
                setTimeout(()=>{
                    document.body.classList.remove("no-transitions")
                }
                , 100)
            }
            , 10)
        }
        )
    }
}
customElements.define("announcement-bar", AnnouncementBar);
const toggleAnnouncement = i=>{
    i.target.classList.contains("mount-announcement") && (document.querySelector(".announcement") ? document.body.classList.add("show-announcement-bar") : document.body.classList.remove("show-announcement-bar"))
}
;
document.addEventListener("shopify:section:load", toggleAnnouncement),
document.addEventListener("shopify:section:select", toggleAnnouncement);
class CartForm extends HTMLElement {
    constructor() {
        super(),
        this.ajaxifyCartItems()
    }
    ajaxifyCartItems() {
        this.form = this.querySelector("form"),
        this.querySelectorAll(".cart-item").forEach(e=>{
            const t = e.querySelector(".remove");
            t && (t.dataset.href = t.getAttribute("href"),
            t.setAttribute("href", ""),
            t.addEventListener("click", r=>{
                r.preventDefault(),
                this.updateCartQty(e, 0)
            }
            ));
            const s = e.querySelector(".qty");
            s && (s.addEventListener("input", debounce(r=>{
                r.preventDefault(),
                r.target.blur(),
                this.updateCartQty(e, parseInt(s.value))
            }
            , 300)),
            s.addEventListener("click", r=>{
                r.target.select()
            }
            ))
        }
        )
    }
    updateCartQty(e, t) {
        this.form.classList.add("processing"),
        this.querySelector(".alert") && this.querySelector(".alert").remove();
        const s = JSON.stringify({
            id: e.dataset.id,
            quantity: t
        });
        fetch(KROWN.settings.routes.cart_change_url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/javascript"
            },
            body: s
        }).then(r=>{
            if (r.ok)
                return fetch("?section_id=cart-helper");
            throw new Error("Something went wrong")
        }
        ).then(r=>r.text()).then(r=>{
            const o = new DOMParser().parseFromString(r, "text/html")
              , n = o.getElementById("AjaxCartForm").innerHTML
              , l = o.getElementById("AjaxCartSubtotal").innerHTML
              , a = document.getElementById("AjaxCartForm");
            if (a.innerHTML = n,
            a.ajaxifyCartItems(),
            document.querySelector("[data-header-cart-count]").textContent = a.querySelector("[data-cart-count]").textContent,
            t != 0 && t > parseInt(a.querySelector(`.cart-item[data-id="${e.dataset.id}"]`).dataset.qty)) {
                let d = document.createElement("span");
                d.classList.add("alert", "alert--error"),
                d.textContent = KROWN.settings.locales.cart_add_error.replace("{{ title }}", e.dataset.title),
                this.form.prepend(d)
            }
            document.getElementById("AjaxCartSubtotal").innerHTML = l,
            window.preloadImages(a)
            if(window.BOLD && BOLD.common && BOLD.common.eventEmitter && typeof BOLD.common.eventEmitter.emit === 'function'){
              BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded');
            }
        }
        ).catch(r=>{
            console.log(r);
            let o = document.createElement("span");
            o.classList.add("alert", "alert--error"),
            o.textContent = KROWN.settings.locales.cart_general_error,
            this.form.prepend(o)
        }
        ).finally(()=>{
            this.form.classList.remove("processing")
        }
        )
    }
}
customElements.define("cart-form", CartForm);
class FacetFiltersForm extends HTMLElement {
    constructor() {
        super(),
        this.filterData = [],
        this.onActiveFilterClick = this.onActiveFilterClick.bind(this),
        this.debouncedOnSubmit = debounce(e=>{
            this.onSubmitHandler(e)
        }
        , 500),
        this.querySelector("form").addEventListener("input", this.debouncedOnSubmit.bind(this)),
        this.classList.contains("don-t-duplicate") || (document.getElementById("FacetFiltersFormMobile").innerHTML = document.getElementById("FacetFiltersForm").innerHTML,
        document.getElementById("FacetFiltersFormMobile").addEventListener("input", this.debouncedOnSubmit.bind(this)),
        document.getElementById("FacetFiltersFormMobile").querySelectorAll(".facets__item").forEach(e=>{
            const t = e.querySelector("input").id;
            e.querySelector("label").setAttribute("for", "mobile-" + t),
            e.querySelector("input").id = "mobile-" + t
        }
        ),
        document.getElementById("FacetFiltersFormMobile").querySelector(".active-facets").classList.remove("active-facets-desktop"),
        document.getElementById("FacetFiltersFormMobile").querySelector(".active-facets").classList.add("active-facets-mobile"))
    }
    static setListeners() {
        window.addEventListener("popstate", e=>{
            const t = e.state ? e.state.searchParams : FacetFiltersForm.searchParamsInitial;
            t !== FacetFiltersForm.searchParamsPrev && FacetFiltersForm.renderPage(t, null, !1)
        }
        )
    }
    static toggleActiveFacets(e=!0) {
        document.querySelectorAll(".js-facet-remove").forEach(t=>{
            t.classList.toggle("disabled", e)
        }
        )
    }
    static renderPage(e, t, s=!0) {
        FacetFiltersForm.searchParamsPrev = e;
        const r = FacetFiltersForm.getSections();
        document.getElementById("main-collection-product-grid").classList.add("loading"),
        r.forEach(o=>{
            const n = `${window.location.pathname}?section_id=${o.section}&${e}`
              , l = a=>a.url === n;
            FacetFiltersForm.filterData.some(l) ? FacetFiltersForm.renderSectionFromCache(l, t) : FacetFiltersForm.renderSectionFromFetch(n, t)
        }
        ),
        s && FacetFiltersForm.updateURLHash(e)
    }
    static renderSectionFromFetch(e, t) {
        fetch(e).then(s=>s.text()).then(s=>{
            const r = s;
            FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, {
                html: r,
                url: e
            }],
            FacetFiltersForm.renderFilters(r, t),
            FacetFiltersForm.renderProductGrid(r),
            FacetFiltersForm.renderProductCount(r)
        }
        )
    }
    static renderSectionFromCache(e, t) {
        const s = FacetFiltersForm.filterData.find(e).html;
        FacetFiltersForm.renderFilters(s, t),
        FacetFiltersForm.renderProductGrid(s),
        FacetFiltersForm.renderProductCount(s)
    }
    static renderProductGrid(e) {
        const t = new DOMParser().parseFromString(e, "text/html").getElementById("CollectionProductGrid").innerHTML;
        document.getElementById("CollectionProductGrid").innerHTML = t,
        window.preloadImages(document.getElementById("CollectionProductGrid"))
    }
    static renderProductCount(e) {
        const t = new DOMParser().parseFromString(e, "text/html").getElementById("CollectionProductCount");
        t && (document.getElementById("CollectionProductCount").innerHTML = t.innerHTML)
    }
    static renderFilters(e, t) {
        const s = new DOMParser().parseFromString(e, "text/html")
          , r = s.querySelectorAll("#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter")
          , o = a=>{
            if (t && t.target.closest(".js-filter"))
                return a.dataset.index === t.target.closest(".js-filter").dataset.index
        }
          , n = Array.from(r).filter(a=>!o(a))
          , l = Array.from(r).find(o);
        n.forEach(a=>{
            document.querySelector(`.js-filter[data-index="${a.dataset.index}"]`).innerHTML = a.innerHTML
        }
        ),
        FacetFiltersForm.renderActiveFacets(s),
        l && FacetFiltersForm.renderCounts(l, t.target.closest(".js-filter"))
    }
    static renderActiveFacets(e) {
        [".active-facets-mobile", ".active-facets-desktop"].forEach(t=>{
            const s = e.querySelector(".active-facets");
            s && document.querySelector(t) && (document.querySelector(t).innerHTML = s.innerHTML)
        }
        ),
        FacetFiltersForm.toggleActiveFacets(!1)
    }
    static renderCounts(e, t) {
        [".facets__selected"].forEach(s=>{
            const r = t.querySelector(s);
            e.querySelector(s) && r && (t.querySelector(s).outerHTML = e.querySelector(s).outerHTML)
        }
        )
    }
    static updateURLHash(e) {
        history.pushState({
            searchParams: e
        }, "", `${window.location.pathname}${e && "?".concat(e)}`)
    }
    static getSections() {
        return [{
            id: "main-collection-product-grid",
            section: document.getElementById("main-collection-product-grid").dataset.id
        }]
    }
    onSubmitHandler(e) {
        e.preventDefault();
        const t = new FormData(e.target.closest("form"))
          , s = new URLSearchParams(t).toString();
        FacetFiltersForm.renderPage(s, e)
    }
    onActiveFilterClick(e) {
        e.preventDefault(),
        FacetFiltersForm.toggleActiveFacets(),
        FacetFiltersForm.renderPage(new URL(e.currentTarget.href).searchParams.toString())
    }
}
FacetFiltersForm.filterData = [],
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1),
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1),
customElements.define("facet-filters-form", FacetFiltersForm),
FacetFiltersForm.setListeners();
class FacetRemove extends HTMLElement {
    constructor() {
        super(),
        this.querySelector("a").addEventListener("click", e=>{
            e.preventDefault(),
            (this.closest("facet-filters-form") || document.querySelector("facet-filters-form")).onActiveFilterClick(e)
        }
        )
    }
}
customElements.define("facet-remove", FacetRemove);
class PriceRange extends HTMLElement {
    constructor() {
        super(),
        this.querySelectorAll("input").forEach(e=>e.addEventListener("change", this.onRangeChange.bind(this))),
        this.setMinAndMaxValues()
    }
    onRangeChange(e) {
        this.adjustToValidValues(e.currentTarget),
        this.setMinAndMaxValues()
    }
    setMinAndMaxValues() {
        const e = this.querySelectorAll("input")
          , t = e[0]
          , s = e[1];
        s.value && t.setAttribute("max", s.value),
        t.value && s.setAttribute("min", t.value),
        t.value === "" && s.setAttribute("min", 0),
        s.value === "" && t.setAttribute("max", s.getAttribute("max"))
    }
    adjustToValidValues(e) {
        const t = Number(e.value)
          , s = Number(e.getAttribute("min"))
          , r = Number(e.getAttribute("max"));
        t < s && (e.value = s),
        t > r && (e.value = r)
    }
}
customElements.define("price-range", PriceRange);
class LocalizationForm extends HTMLElement {
    constructor() {
        super(),
        this.selector = this.querySelector(".regular-select-cover"),
        this.content = this.querySelector(".regular-select-content"),
        this.selector.addEventListener("click", e=>{
            e.stopPropagation(),
            e.preventDefault(),
            document.querySelectorAll(".regular-select-cover.content-opened").forEach(t=>{
                t != e.currentTarget && (t.classList.remove("content-opened"),
                t.parentNode.style.zIndex = 9)
            }
            ),
            this.content.classList.contains("content-opened") ? (e.currentTarget.setAttribute("aria-expanded", "false"),
            this.content.parentNode.style.zIndex = 9,
            this.content.classList.remove("content-opened", "invert"),
            window.removeEventListener("click", this.onClickHandler)) : (this.content.classList.add("content-opened"),
            e.currentTarget.setAttribute("aria-expanded", "true"),
            this.content.parentNode.style.zIndex = 1e3,
            this.content.classList.contains("invert-with-fixed") && this.content.getBoundingClientRect().y + this.content.offsetHeight + 55 > window.innerHeight && this.content.classList.add("invert"),
            this.onClickHandler = (()=>{
                this.content.classList.contains("content-opened") && (this.content.classList.remove("content-opened", "invert"),
                this.content.parentNode.style.zIndex = 9)
            }
            ).bind(this),
            window.addEventListener("click", this.onClickHandler))
        }
        ),
        this.querySelector(".regular-select-cover").addEventListener("keydown", function(e) {
            e.keyCode == window.KEYCODES.RETURN && (this.content.classList.contains("opened-with-tab") || (this.content.classList.add("opened-with-tab"),
            this.content.querySelectorAll(".regular-select-item").forEach(t=>{
                t.setAttribute("tabindex", "0")
            }
            )))
        })
    }
}
customElements.define("localization-form", LocalizationForm);
class ModalBox extends HTMLElement {
    constructor() {
        if (super(),
        this.o = {
            show: 10,
            frequency: "day",
            enabled: !0,
            ...JSON.parse(this.dataset.options)
        },
        this._modalKey = `modal-${document.location.hostname}-${this.id}`,
        this._modalStorage = localStorage.getItem(this._modalKey) ? JSON.parse(localStorage.getItem(this._modalKey)) : "empty",
        this._modalText = this.extractText(this.querySelector("[data-content]")),
        this.o.enabled) {
            const e = new Date().getTime()
              , t = Math.round((e - this._modalStorage.shown) / 1e3);
            let s = !1;
            (this._modalStorage == "empty" || this.o.frequency == "day" && t > 86400 || this.o.frequency == "week" && t > 604800 || this.o.frequency == "month" && t > 2419200 || this._modalStorage.content != this._modalText) && (s = !0),
            s && (setTimeout(()=>{
                this.show()
            }
            , parseInt(1e3 * this.o.show)),
            setTimeout(()=>{
                this.querySelectorAll("[data-close]").forEach(r=>r.addEventListener("click", ()=>{
                    this.hide(!0)
                }
                ))
            }
            , 100))
        }
        this.setAttribute("style", "")
    }
    show() {
        window.preloadImages(this),
        this.classList.add("active")
    }
    hide(e=!1) {
        this.classList.remove("active"),
        e && !Shopify.designMode && localStorage.setItem(this._modalKey, JSON.stringify({
            shown: new Date().getTime(),
            content: this._modalText
        }))
    }
    extractText(e) {
        let t = document.createElement("span");
        t.innerHTML = e.innerHTML;
        const s = t.textContent || t.innerText;
        return t.remove(),
        [s].toString().replace(/ +/g, "")
    }
}
customElements.define("modal-box", ModalBox),
document.addEventListener("shopify:section:select", i=>{
    i.target.classList.contains("mount-popup") && i.target.querySelector("modal-box").show()
}
),
document.addEventListener("shopify:section:deselect", i=>{
    i.target.classList.contains("mount-popup") && i.target.querySelector("modal-box").hide()
}
);
class ProductVariants extends HTMLElement {
    constructor() {
        super(),
        this.price = document.querySelector("#product-price-" + this.dataset.id),
        this.price && (this.priceOriginal = this.price.querySelector(".product__price--original"),
        this.priceCompare = this.price.querySelector(".product__price--compare"),
        this.priceUnit = this.price.querySelector(".product__price--unit")),
        this.productForm = document.querySelector("#product-form-" + this.dataset.id),
        this.productForm && (this.productQty = this.productForm.querySelector(".product__quantity"),
        this.addToCart = this.productForm.querySelector(".product__add-to-cart"),
        this.addToCartText = this.productForm.querySelector(".add-to-cart__text")),
        this.productSKU = document.querySelector(`#product-${this.dataset.id} .product__sku`),
        this.productBARCODE = document.querySelector(`#product-${this.dataset.id} .product__barcode`),
        this.addEventListener("change", this.onVariantChange),
        this.updateOptions(),
        this.updateMasterId(),
        this.updateUnavailableVariants(),
        this.productStock = this.querySelector(".variant-quantity"),
        this.productStock && this.querySelector(".variant-quantity-data") && (this.productStockData = JSON.parse(this.querySelector(".variant-quantity-data").dataset.inventory)),
        this.updateStock(),
        this._event = new Event("VARIANT_CHANGE")
    }
    onVariantChange() {
        this.updateOptions(),
        this.updateMasterId(),
        this.updateVariantInput(),
        this.price && this.updatePrice(),
        this.updateStock(),
        this.updateUnavailableVariants(),
        this.updatePickupAvailability(),
        this.hasAttribute("data-no-history") || this.updateURL(),
        this.updateDetails(),
        this.productForm && (this.currentVariant && this.currentVariant.available ? (this.productQty && (this.productQty.style.display = ""),
        this.addToCart.classList.remove("disabled"),
        this.productForm.classList.remove("disabled-cart"),
        this.addToCartText.textContent = KROWN.settings.locales.products_add_to_cart_button) : (this.productQty && (this.productQty.style.display = "none"),
        this.addToCart.classList.add("disabled"),
        this.productForm.classList.add("disabled-cart"),
        this.addToCartText.textContent = KROWN.settings.locales.products_sold_out_variant),
        this.currentVariant ? this.productForm.classList.remove("unavailable-variant") : (this.productForm.classList.add("unavailable-variant"),
        this.addToCartText.textContent = KROWN.settings.locales.products_unavailable_variant)),
        this.dispatchEvent(this._event)
    }
    updateOptions() {
        this.dataset.type == "select" ? this.options = Array.from(this.querySelectorAll(".product-variant-container"), e=>e.value) : this.dataset.type == "radio" && (this.options = [],
        this.querySelectorAll(".product-variant__input").forEach(e=>{
            e.checked && this.options.push(e.value)
        }
        ))
    }
    updateMasterId() {
        this.currentVariant = this.getVariantData().find(e=>!e.options.map((t,s)=>this.options[s] === t).includes(!1))
    }
    updatePrice() {
        this.currentVariant ? (this.priceOriginal.innerHTML = KROWN.helpers.formatMoney(this.currentVariant.price, KROWN.settings.shop_money_format),
        this.currentVariant.compare_at_price > this.currentVariant.price ? (this.priceCompare.innerHTML = KROWN.helpers.formatMoney(this.currentVariant.compare_at_price, KROWN.settings.shop_money_format),
        this.priceCompare.style.display = "") : this.priceCompare.style.display = "none",
        this.currentVariant.unit_price_measurement ? this.priceUnit.innerHTML = `
					${KROWN.helpers.formatMoney(this.currentVariant.unit_price, KROWN.settings.shop_money_format)} / 
					${this.currentVariant.unit_price_measurement.reference_value != 1 ? this.currentVariant.unit_price_measurement.reference_value + " " : ""}
					${this.currentVariant.unit_price_measurement.reference_unit}
				` : this.priceUnit.innerHTML = "") : (this.priceOriginal.innerHTML = "",
        this.priceCompare.style.display = "none",
        this.priceUnit.innerHTML = "")
    }
    updateStock() {
        if (this.currentVariant) {
            if (this.productStock && this.productStockData) {
                let e = !1;
                for (const t of this.productStockData)
                    if (t.id == this.currentVariant.id) {
                        e = t;
                        break
                    }
                this.productStock.innerHTML = "",
                e && (e.quantity <= 0 ? e.inventory == "continue" ? this.productStock.innerHTML = KROWN.settings.locales.products_preorder : e.inventory == "deny" && (this.productStock.innerHTML = KROWN.settings.locales.products_no_products) : e.quantity == "1" ? this.productStock.innerHTML = KROWN.settings.locales.products_one_product : e.quantity <= 5 ? this.productStock.innerHTML = KROWN.settings.locales.products_few_products.replace("{{ count }}", e.quantity) : e.unavailable ? this.productStock.innerHTML = KROWN.settings.locales.products_no_products : e.quantity > 5 && this.productStock.dataset.type == "always" && (this.productStock.innerHTML = KROWN.settings.locales.products_few_products.replace("{{ count }}", e.quantity)))
            }
        } else
            this.productStock && (this.productStock.innerHTML = "")
    }
    updateDetails() {
        this.productSKU && (this.currentVariant.sku ? this.productSKU.textContent = KROWN.settings.locales.product_sku + this.currentVariant.sku : this.productSKU.textContent = ""),
        this.productBARCODE && (this.currentVariant.barcode ? this.productBARCODE.textContent = KROWN.settings.locales.product_barcode + this.currentVariant.barcode : this.productBARCODE.textContent = "")
    }
    updatePickupAvailability() {
        const e = document.querySelector("pickup-availability");
        e && (this.currentVariant && this.currentVariant.available ? e.fetchAvailability(this.currentVariant.id) : (e.removeAttribute("available"),
        e.innerHTML = ""))
    }
    updateUnavailableVariants() {
        if (this.dataset.hideVariants == "true") {
            let e = {}
              , t = {}
              , s = {}
              , r = null
              , o = null;
            this.dataset.variants > 1 && (r = this._getSelectedOption(0),
            this._resetDisabledOption(1)),
            this.dataset.variants > 2 && (o = this._getSelectedOption(1),
            this._resetDisabledOption(2)),
            this.getVariantData().forEach(n=>{
                this.dataset.variants > 0 && (e[n.option1] || (e[n.option1] = []),
                e[n.option1].push(String(n.available))),
                this.dataset.variants > 1 && (t[n.option2] || (t[n.option2] = []),
                t[n.option2].push(String(n.available))),
                this.dataset.variants == 2 && (n.option1 != r || n.available || this._setDisabledOption(1, n.option2)),
                this.dataset.variants > 2 && (s[n.option3] || (s[n.option3] = []),
                s[n.option3].push(String(n.available)),
                n.option2 != o || n.option1 != r || n.available || this._setDisabledOption(2, n.option3))
            }
            ),
            this.dataset.variants > 0 && Object.keys(e).forEach(n=>{
                e[n].includes("true") || this.querySelectorAll(".product-variant")[0].querySelector(`.product-variant-value[value="${n}"]`).setAttribute("disabled", "disabled")
            }
            ),
            this.dataset.variants > 1 && Object.keys(t).forEach(n=>{
                t[n].includes("true") || this.querySelectorAll(".product-variant")[1].querySelector(`.product-variant-value[value="${n}"]`).setAttribute("disabled", "disabled")
            }
            ),
            this.dataset.variants > 2 && (Object.keys(s).forEach(n=>{
                s[n].includes("true") || this.querySelectorAll(".product-variant")[2].querySelector(`.product-variant-value[value="${n}"]`).setAttribute("disabled", "disabled")
            }
            ),
            Object.keys(t).forEach(n=>{
                t[n].includes("true") || o == n && this.querySelectorAll(".product-variant")[2].querySelector(".product-variant-value").setAttribute("disabled", "disabled")
            }
            ))
        }
    }
    _getSelectedOption(e) {
        if (this.dataset.type == "select")
            return this.querySelectorAll(".product-variant")[e].querySelector(".product-variant-container").value;
        if (this.dataset.type == "radio") {
            let t = null;
            return this.querySelectorAll(".product-variant")[e].querySelectorAll(".product-variant__input").forEach(s=>{
                s.checked && (t = s.value)
            }
            ),
            t
        }
    }
    _resetDisabledOption(e) {
        this.querySelectorAll(".product-variant")[e].querySelectorAll(".product-variant-value").forEach(t=>{
            t.removeAttribute("disabled")
        }
        )
    }
    _setDisabledOption(e, t) {
        this.querySelectorAll(".product-variant")[e].querySelector(`.product-variant-value[value="${t}"]`).setAttribute("disabled", "disabled")
    }
    updateURL() {
        this.currentVariant && window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`)
    }
    updateVariantInput() {
        !this.currentVariant || document.querySelectorAll(`#product-form-${this.dataset.id}, #product-form-installment`).forEach(e=>{
            const t = e.querySelector('input[name="id"]');
            t.value = this.currentVariant.id,
            t.dispatchEvent(new Event("change",{
                bubbles: !0
            }))
        }
        )
    }
    getVariantData() {
        return this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent),
        this.variantData
    }
}
customElements.define("product-variants", ProductVariants);
class ProductForm extends HTMLElement {
    constructor() {
        super(),
        this.init()
    }
    init() {
        this.hasAttribute("data-ajax-cart") && !document.body.classList.contains("template-cart") && (this.form = this.querySelector("form"),
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this)),
        this.ADD_TO_CART = new Event("add-to-cart"))
    }
    onSubmitHandler(e) {
        e.preventDefault();
        const t = this.querySelector('[type="submit"]');
        t.classList.add("working");
        const s = serializeForm(this.form);
        let r = "";
        var formdata = false;
        if(window.FormData){
          formdata = new FormData(this.form);
        }
        fetch(KROWN.settings.routes.cart_add_url + ".js", {
            body: formdata ? formdata : s,
            contentType : false,
			processData : false,
            
//             headers: {
//                 "Content-Type": "application/x-www-form-urlencoded",
//                 "X-Requested-With": "XMLHttpRequest"
//             },
            method: "POST"
        }).then(o=>o.json()).then(o=>(o.status == 422 && (r = document.createElement("span"),
        r.className = "alert body-text-sm alert--error",
        r.innerHTML = o.description),
        fetch("?section_id=cart-helper"))).then(o=>o.text()).then(o=>{
            const n = new DOMParser().parseFromString(o, "text/html")
              , l = n.getElementById("AjaxCartForm").innerHTML
              , a = n.getElementById("AjaxCartSubtotal").innerHTML
              , d = document.getElementById("AjaxCartForm");
            d.innerHTML = l,
            d.ajaxifyCartItems(),
            r != "" && document.getElementById("AjaxCartForm").querySelector("form").prepend(r),
            document.getElementById("AjaxCartSubtotal").innerHTML = a,
            window.preloadImages(d),
            document.querySelector("[data-header-cart-count]").textContent = document.querySelector("#AjaxCartForm [data-cart-count]").textContent,
            this.dispatchEvent(this.ADD_TO_CART)
            if(window.BOLD && BOLD.common && BOLD.common.eventEmitter && typeof BOLD.common.eventEmitter.emit === 'function'){
              BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded');
            }
        }
        ).catch(o=>{
            console.log(o)
        }
        ).finally(()=>{
            t.classList.remove("working")
        }
        )
    }
}
customElements.define("product-form", ProductForm);
class PickupAvailability extends HTMLElement {
    constructor() {
        super(),
        this.errorHtml = this.querySelector("template").content.firstElementChild.cloneNode(!0),
        this.onClickRefreshList = this.onClickRefreshList.bind(this),
        this.hasAttribute("available") && this.fetchAvailability(this.dataset.variantId)
    }
    fetchAvailability(e) {
        const t = `${this.dataset.baseUrl}variants/${e}/?section_id=pickup-availability`;
        fetch(t).then(s=>s.text()).then(s=>{
            const r = new DOMParser().parseFromString(s, "text/html").querySelector(".shopify-section");
            this.renderPreview(r)
        }
        ).catch(s=>{
            console.log(s),
            this.querySelector("button") && this.querySelector("button").removeEventListener("click", this.onClickRefreshList),
            this.renderError()
        }
        )
    }
    onClickRefreshList() {
        this.fetchAvailability(this.dataset.variantId)
    }
    renderError() {
        this.innerHTML = "",
        this.appendChild(this.errorHtml),
        this.querySelector("button").addEventListener("click", this.onClickRefreshList)
    }
    renderPreview(e) {
        const t = document.getElementById("PickupAvailabilityDrawer");
        if (t && t.remove(),
        !e.querySelector("pickup-availability-preview"))
            return this.innerHTML = "",
            void this.removeAttribute("available");
        this.innerHTML = e.querySelector("pickup-availability-preview").outerHTML,
        this.setAttribute("available", ""),
        document.body.appendChild(e.querySelector("#PickupAvailabilityDrawer")),
        this.querySelector("button").addEventListener("click", s=>{
            document.getElementById("PickupAvailabilityDrawer").show(s.target)
        }
        ),
        this.querySelector("button").addEventListener("keyup", s=>{
            s.keyCode == window.KEYCODES.RETURN && document.getElementById("PickupAvailabilityDrawer").querySelector("[data-close]").focus()
        }
        )
    }
}
customElements.define("pickup-availability", PickupAvailability);
class ProductImageZoom extends HTMLElement {
    constructor() {
        super(),
        document.getElementById("zoom") ? this.zoom = document.getElementById("zoom") : (this.zoom = document.createElement("div"),
        this.zoom.id = "zoom",
        this.zoom.innerHTML = `
				<img />
				<span class="zoom__exit">${KROWN.settings.symbols.zoom_out}</span>
				<div class="zoom__overlay"></div>
			`,
        document.body.append(this.zoom),
        this.zoom.querySelector(".zoom__exit").addEventListener("click", this._productZoomUnmount.bind(this))),
        this.onMouseMoveHandlerBinded = this.onMouseMoveHandler.bind(this),
        this.onResizeHandlerBinded = this.onResizeHandler.bind(this),
        this.addEventListener("click", e=>{
            this.zoom.classList.add("opened"),
            this.image = this.zoom.querySelector("img"),
            this.image.src = this.getAttribute("data-image"),
            this.image.naturalWidth > 0 ? this._productZoomMount() : this.image.addEventListener("load", this._productZoomMount.bind(this))
        }
        )
    }
    onMouseMoveHandler(e) {
        window.clientX = e.clientX,
        window.clientY = e.clientY;
        const t = e.clientX * (window.innerWidth - this.image.offsetWidth) / window.innerWidth
          , s = e.clientY * (window.innerHeight - this.image.offsetHeight) / window.innerHeight;
        this.image.style.left = t + "px",
        this.image.style.top = s + "px"
    }
    onResizeHandler() {
        const e = window.innerWidth > 768 ? 1 : 2;
        this.image.classList.contains("portrait") ? (this.image.style.width = window.innerWidth * e + "px",
        this.image.style.height = window.innerWidth * e / this.image.dataset.ratio + "px") : (this.image.style.height = window.innerHeight * e + "px",
        this.image.style.width = window.innerHeight * e * this.image.dataset.ratio + "px",
        this.image.offsetWidth < window.innerWidth && (this.image.style.width = window.innerWidth * e + "px",
        this.image.style.height = window.innerWidth * e / this.image.dataset.ratio + "px")),
        window.clientX,
        window.innerWidth,
        this.image.offsetWidth,
        window.innerWidth,
        window.clientY,
        window.innerHeight,
        this.image.offsetHeight,
        window.innerHeight
    }
    _productZoomMount(e) {
        this.image.style.left = 0,
        this.image.style.top = 0,
        window.addEventListener("mousemove", this.onMouseMoveHandlerBinded, {
            passive: !0
        }),
        this.image.dataset.ratio = this.image.naturalWidth / this.image.naturalHeight,
        window.addEventListener("resize", this.onResizeHandlerBinded, {
            passive: !0
        }),
        this.onResizeHandler(),
        setTimeout(()=>{
            (document.body.classList.contains("touch") || document.body.classList.contains("touchevents")) && (this.zoom.scrollTop = (window.innerHeight - this.image.offsetHeight) / -2,
            this.zoom.scrollLeft = (window.innerWidth - this.image.offsetWidth) / -2),
            this.zoom.classList.add("loaded")
        }
        , 50)
    }
    _productZoomUnmount() {
        this.zoom.classList.remove("opened"),
        setTimeout(()=>{
            window.removeEventListener("resize", this.onResizeHandlerBinded),
            window.removeEventListener("mousemove", this.onMouseMoveHandlerBinded);
            const e = document.querySelector("#zoom img");
            e.src = "",
            e.className = "",
            e.style = "",
            this.zoom.classList.remove("loaded")
        }
        , 300)
    }
}
customElements.define("product-image-zoom", ProductImageZoom);
class SearchForm extends HTMLElement {
    constructor() {
        if (super(),
        this.cachedResults = {},
        this.input = this.querySelector("[data-search-input]"),
        this.predictiveSearchResults = this.querySelector("[data-search-results]"),
        this.results = [],
        this.preloader = !1,
        KROWN.settings.predictive_search_enabled != "false") {
            let e = this.input.value;
            this.input.addEventListener("keyup", debounce(t=>{
                this.input.value != e ? (e = this.input.value,
                this.getSearchResults(this.input.value.trim())) : this.input.value == "" && this.clearSearchResults()
            }
            , 150)),
            this.input.addEventListener("keydown", t=>{
                this.a11yIndex != -1 && (t.keyCode !== window.KEYCODES.UP && t.keyCode !== window.KEYCODES.DOWN && t.keyCode !== window.KEYCODES.RETURN || t.preventDefault())
            }
            ),
            this.input.addEventListener("keyup", t=>t.keyCode === window.KEYCODES.UP ? (this.navigateThrough("UP"),
            !0) : t.keyCode === window.KEYCODES.DOWN ? (this.navigateThrough("DOWN"),
            !0) : void (t.keyCode === window.KEYCODES.RETURN && this.a11yIndex != -1 && (document.location.href = this.results[this.a11yIndex].querySelector("a"))))
        }
    }
    getSearchResults(e="") {
        this.preloadSearchResults();
        const t = e.replace(" ", "-").toLowerCase();
        this.cachedResults[t] ? this.renderSearchResults(this.cachedResults[t]) : (this.a11yIndex = -1,
        fetch(`${KROWN.settings.routes.predictive_search_url}?q=${encodeURIComponent(e)}&resources[type]=${this.dataset.resourceType}&resources[limit]=4&section_id=predictive-search`).then(s=>{
            if (!s.ok) {
                var r = new Error(s.status);
                throw this.clearSearchResults(),
                r
            }
            return s.text()
        }
        ).then(s=>{
            const r = new DOMParser().parseFromString(s, "text/html").querySelector("#shopify-section-predictive-search").innerHTML;
            this.cachedResults[t] = r,
            this.renderSearchResults(r)
        }
        ).catch(s=>{
            throw s
        }
        ))
    }
    clearSearchResults() {
        this.predictiveSearchResults.innerHTML = "",
        this.preloader = !1,
        this.results = []
    }
    preloadSearchResults() {
        this.preloader || (this.preloader = !0,
        this.predictiveSearchResults.innerHTML = KROWN.settings.predictive_search_placeholder)
    }
    renderSearchResults(e) {
        this.predictiveSearchResults.innerHTML = e,
        this.preloader = !1,
        this.results = this.predictiveSearchResults.querySelectorAll(".search-item, .sidebar__search-link"),
        window.preloadImages(this.predictiveSearchResults)
    }
    navigateThrough(e) {
        this.a11yIndex == -1 ? this.a11yIndex = 0 : (this.results[this.a11yIndex].classList.remove("active"),
        e == "UP" ? this.a11yIndex - 1 >= -1 && this.a11yIndex-- : e == "DOWN" && this.a11yIndex + 1 < this.results.length && this.a11yIndex++),
        this.a11yIndex >= 0 ? (this.results[this.a11yIndex].classList.add("active"),
        document.getElementById("site-search-sidebar").scrollTop = this.results[this.a11yIndex].offsetTop - 200) : document.getElementById("site-search-sidebar").scrollTop = 0
    }
}
customElements.define("search-form", SearchForm);
class CSSSlider extends HTMLElement {
    constructor() {
        super(),
        this._touchScreen = "ontouchstart"in window || window.DocumentTouch && document instanceof DocumentTouch;
        const e = navigator.userAgent.toLowerCase();
        this._ios15 = this._touchScreen && e.includes("applewebkit") && (e.includes("os 15_") || e.includes("version/15")),
        this.o = {
            selector: ".css-slide",
            snapping: !0,
            groupCells: !1,
            autoHeight: !1,
            navigation: !0,
            navigationDOM: `<span class="css-slider-button css-slider-prev" style="display:none">\u2190</span>
					<span class="css-slider-button css-slider-next" style="display:none">\u2192</span>`,
            thumbnails: !0,
            thumbnailsDOM: '<div class="css-slider-dot-navigation" style="display:none"></div>',
            indexNav: !1,
            indexNavDOM: '<div class="css-slider-index-navigation"><span class="css-slider-current">1</span> / <span class="css-slider-total">1</span></div>',
            watchCSS: !1,
            undisplay: !1,
            listenScroll: !1,
            ...JSON.parse(this.dataset.options)
        },
        this.o.watchCSS ? (this.RESIZE_WATCHER = debounce(()=>{
            const t = window.getComputedStyle(this, ":after").content;
            t.includes("css-slide") && !this.sliderEnabled ? this.initSlider() : !t.includes("css-slide") && this.sliderEnabled && this.destroySlider()
        }
        , 100),
        window.addEventListener("resize", this.RESIZE_WATCHER),
        this.RESIZE_WATCHER()) : this.initSlider()
    }
    destroySlider() {
        this.innerHTML = "" + this.originalHTML,
        this.classList.remove("enabled"),
        this.sliderEnabled = !1,
        window.removeEventListener("resize", this.RESIZE_EVENT),
        window.removeEventListener("scroll", this.SCROLL_EVENT),
        window.removeEventListener("scroll", this.SCROLL_EVENT_ANIMATION),
        window.preloadImages(this)
    }
    initSlider() {
        if (this._readyEvent = new CustomEvent("ready"),
        this._changeEvent = new CustomEvent("change"),
        this._scrollEvent = new CustomEvent("scroll"),
        this._navEvent = new CustomEvent("navigation"),
        this._pointerDownEvent = new CustomEvent("pointerDown"),
        this._pointerUpEvent = new CustomEvent("pointerUp"),
        this.classList.add("css-slider"),
        this.originalHTML = this.innerHTML,
        this.innerHTML = `<div class="css-slider-viewport">
      <div class="css-slider-holder">
        <div class="css-slider-container">
          ${this.originalHTML}
        </div>
      </div>
    </div>`,
        window.preloadImages(this),
        this.o.undisplay && this.querySelectorAll("" + this.o.selector).forEach(e=>{
            e.style.display = "block"
        }
        ),
        this.o.selector != ".css-slide" && this.querySelectorAll("" + this.o.selector).forEach(e=>{
            e.classList.add("css-slide")
        }
        ),
        this.element = this.querySelector(".css-slider-holder"),
        this.o.groupCells && (this.element.scrollLeft = 0),
        this.items = this.querySelectorAll("" + this.o.selector),
        this.indexedItems = [],
        this.index = 0,
        this.length = this.items.length,
        this.windowWidth = window.innerWidth,
        this.viewport = this.querySelector(".css-slider-viewport"),
        this.o.autoHeight && this.viewport.classList.add("auto-height"),
        this.o.navigation || this.o.thumbnails || this.indexNav) {
            let e = document.createElement("div");
            e.classList.add("css-slider-navigation-container"),
            e.innerHTML = `
        ${this.o.navigation ? this.o.navigationDOM : ""}
        ${this.o.thumbnails ? this.o.thumbnailsDOM : ""}
        ${this.o.indexNav ? this.o.indexNavDOM : ""}`,
            this.o.navigation && (this.prevEl = e.querySelector(".css-slider-prev"),
            this.prevEl.addEventListener("click", t=>{
                this.changeSlide("prev"),
                this.dispatchEvent(this._navEvent)
            }
            ),
            this.nextEl = e.querySelector(".css-slider-next"),
            this.nextEl.addEventListener("click", t=>{
                this.changeSlide("next"),
                this.dispatchEvent(this._navEvent)
            }
            )),
            this.o.thumbnails && (this.thumbnailsEl = e.querySelector(".css-slider-dot-navigation")),
            this.o.indexNav && (this.indexEl = e.querySelector(".css-slider-current"),
            this.lengthEl = e.querySelector(".css-slider-total")),
            this.append(e)
        }
        this.length > 1 && (this.RESIZE_EVENT = debounce(()=>{
            this.windowWidth != window.innerWidth && this.o.groupCells && this.resetSlider(),
            this.o.groupCells || this.checkSlide(),
            this.windowWidth = window.innerWidth
        }
        , 100),
        window.addEventListener("resize", this.RESIZE_EVENT),
        this.resetSlider(!0),
        this.o.listenScroll && (this.SCROLL_EVENT_ANIMATIONS = ()=>{
            let e = -this.querySelector(".css-slider-container").offsetWidth;
            this.items.forEach(t=>{
                e += t.offsetWidth
            }
            ),
            this.progress = this.element.scrollLeft / e,
            this.dispatchEvent(this._scrollEvent)
        }
        ,
        this.element.addEventListener("scroll", this.SCROLL_EVENT_ANIMATIONS, {
            passive: !0
        })),
        this.SCROLL_EVENT = debounce(()=>{
            if (!this._sliderBlockScroll) {
                const e = this.indexedItems.entries()
                  , t = Array.from(e, o=>Math.abs(o[1].offsetLeft - this.element.scrollLeft))
                  , s = Math.min(...t)
                  , r = t.indexOf(s);
                r != this.index && (this.index = r,
                this.checkSlide(),
                this.dispatchEvent(this._changeEvent))
            }
        }
        , 10),
        this.element.addEventListener("scroll", this.SCROLL_EVENT, {
            passive: !0
        }),
        this._touchScreen || this.element.classList.contains("css-slider--singular") || (this.element.addEventListener("mousedown", e=>{
            this.element.classList.contains("css-slider--disable-dragging") || (this.mouseX = e.screenX,
            this.element.classList.add("can-drag"),
            this.element.classList.add("mouse-down"))
        }
        ),
        this.element.addEventListener("mouseup", e=>{
            this.element.classList.remove("mouse-down"),
            this.element.classList.remove("can-drag"),
            this.element.classList.remove("pointer-events-off")
        }
        ),
        this.element.addEventListener("mouseleave", e=>{
            this.element.classList.remove("mouse-down"),
            this.element.classList.remove("can-drag"),
            this.element.classList.remove("pointer-events-off")
        }
        ),
        this.element.addEventListener("mousemove", e=>{
            if (this.element.classList.contains("can-drag")) {
                this.element.classList.add("pointer-events-off");
                let t = this.mouseX - e.screenX;
                Math.abs(t) > 1 && (t > 0 ? (this.changeSlide("next"),
                this.element.classList.remove("can-drag")) : t < 0 && (this.changeSlide("prev"),
                this.element.classList.remove("can-drag")))
            }
        }
        )),
        "scrollBehavior"in document.documentElement.style || this._touchScreen || this.element.classList.add("force-disable-snapping")),
        this.classList.add("enabled"),
        this.sliderEnabled = !0,
        this.dispatchEvent(this._readyEvent)
    }
    changeSlide(e, t="smooth") {
        e == "next" ? this.index + 1 < this.length && this.index++ : e == "prev" ? this.index - 1 >= 0 && this.index-- : parseInt(e) >= 0 && (this.index = parseInt(e)),
        this._sliderBlockScroll = !0,
        this._ios15 && this.element.classList.add("force-disable-snapping"),
        setTimeout(()=>{
            this._sliderBlockScroll = !1,
            this._ios15 && this.element.classList.remove("force-disable-snapping")
        }
        , 500),
        this.checkSlide(),
        this.element.scrollTo({
            top: 0,
            left: this.indexedItems[this.index].offsetLeft - parseInt(getComputedStyle(this.indexedItems[0]).marginLeft),
            behavior: t
        }),
        this.dispatchEvent(this._changeEvent)
    }
    checkSlide() {
        this.o.navigation && (this.prevEl.classList.remove("disabled"),
        this.nextEl.classList.remove("disabled"),
        this.index == 0 && this.prevEl.classList.add("disabled"),
        this.index == this.length - 1 && this.nextEl.classList.add("disabled")),
        this.o.thumbnails && this.thumbnails && (this.thumbnails.forEach(e=>{
            e.classList.remove("active")
        }
        ),
        this.thumbnails[this.index].classList.add("active")),
        this.o.indexNav && (this.indexEl.textContent = this.index + 1),
        this.o.autoHeight && (this.viewport.style.height = this.indexedItems[this.index].offsetHeight + "px"),
        this.indexedItems.forEach((e,t)=>{
            t == this.index ? e.classList.add("css-slide-active") : e.classList.remove("css-slide-active")
        }
        )
    }
    afterAppend() {
        this.items = this.querySelectorAll("" + this.o.selector)
    }
    resetSlider(e=!1, t=!0) {
        let s = 0
          , r = 0
          , o = 0
          , n = this.querySelector(".css-slider-container").offsetWidth
          , l = !1;
        if (this.indexedItems = [],
        this.element.classList.add("disable-snapping"),
        this.items.forEach((a,d)=>{
            a.classList.remove("css-slide--snap"),
            s += a.offsetWidth,
            s > n && r == 0 && (r = d)
        }
        ),
        r == 0 && (r = this.items.length,
        l = !0),
        this.items.forEach((a,d)=>{
            d % r == 0 && (a.classList.add("css-slide--snap"),
            a.setAttribute("data-index", o++))
        }
        ),
        this.indexedItems = this.querySelectorAll(".css-slide--snap"),
        t && (this.index = 0),
        this.length = Math.ceil(this.items.length / r),
        this.o.thumbnails) {
            this.thumbnailsEl.innerHTML = "";
            for (let a = 0; a < this.length; a++) {
                let d = document.createElement("span");
                d.classList.add("css-slider-dot"),
                d.dataset.index = a,
                this.thumbnailsEl.appendChild(d),
                d.addEventListener("click", h=>{
                    this.changeSlide(h.target.dataset.index)
                }
                )
            }
            this.thumbnails = this.thumbnailsEl.querySelectorAll(".css-slider-dot")
        }
        this.o.indexNav && (this.indexEl.textContent = this.index + 1,
        this.lengthEl.textContent = this.length),
        l ? (this.element.classList.add("css-slider--no-drag"),
        this.o.navigation && (this.prevEl.style.display = "none",
        this.nextEl.style.display = "none"),
        this.o.thumbnails && (this.thumbnailsEl.style.display = "none")) : (this.element.classList.remove("css-slider--no-drag"),
        this.o.navigation && (this.prevEl.style.display = "block",
        this.nextEl.style.display = "block"),
        this.o.thumbnails && (this.thumbnailsEl.style.display = "block")),
        this.checkSlide(),
        e || this.element.scrollTo({
            top: 0,
            left: 0,
            behavior: "auto"
        }),
        this.element.classList.remove("disable-snapping")
    }
}
customElements.define("css-slider", CSSSlider),
document.addEventListener("shopify:section:load", i=>{
    i.target.classList.contains("mount-css-slider") && i.target.querySelector("css-slider") && i.target.querySelectorAll("css-slider").forEach(e=>{
        e.enabled && e.resetSlider()
    }
    )
}
);
class ToggleTab extends HTMLElement {
    constructor() {
        super(),
        this.titleEl = this.querySelector(".toggle__title"),
        this.contentEl = this.querySelector(".toggle__content"),
        this.titleEl.innerHTML = `${this.titleEl.innerHTML}${KROWN.settings.symbols.toggle_pack}`,
        this.titleEl.addEventListener("click", this.onClickHandler.bind(this)),
        this.titleEl.addEventListener("keydown", e=>{
            e.keyCode == window.KEYCODES.RETURN && this.onClickHandler()
        }
        )
    }
    onClickHandler() {
        this.titleEl.classList.contains("opened") ? (this.titleEl.classList.remove("opened"),
        this.titleEl.setAttribute("aria-expanded", "false"),
        this.slideUp(this.contentEl, 200)) : (this.titleEl.classList.add("opened"),
        this.titleEl.setAttribute("aria-expanded", "true"),
        this.slideDown(this.contentEl, 200))
    }
    slideUp(e, t) {
        e.style.transitionProperty = "height, margin, padding",
        e.style.transitionDuration = t + "ms",
        e.style.boxSizing = "border-box",
        e.style.height = e.offsetHeight + "px",
        e.offsetHeight,
        e.style.overflow = "hidden",
        e.style.height = 0,
        e.style.paddingTop = 0,
        e.style.paddingBottom = 0,
        e.style.marginTop = 0,
        e.style.marginBottom = 0,
        setTimeout(()=>{
            e.style.display = "none",
            e.style.removeProperty("height"),
            e.style.removeProperty("padding-top"),
            e.style.removeProperty("padding-bottom"),
            e.style.removeProperty("margin-top"),
            e.style.removeProperty("margin-bottom"),
            e.style.removeProperty("overflow"),
            e.style.removeProperty("transition-duration"),
            e.style.removeProperty("transition-property")
        }
        , t)
    }
    slideDown(e, t) {
        e.style.removeProperty("display");
        var s = window.getComputedStyle(e).display;
        s === "none" && (s = "block"),
        e.style.display = s;
        var r = e.offsetHeight;
        e.style.overflow = "hidden",
        e.style.height = 0,
        e.style.paddingTop = 0,
        e.style.paddingBottom = 0,
        e.style.marginTop = 0,
        e.style.marginBottom = 0,
        e.offsetHeight,
        e.style.boxSizing = "border-box",
        e.style.transitionProperty = "height, margin, padding",
        e.style.transitionDuration = t + "ms",
        e.style.height = r + "px",
        e.style.removeProperty("padding-top"),
        e.style.removeProperty("padding-bottom"),
        e.style.removeProperty("margin-top"),
        e.style.removeProperty("margin-bottom"),
        setTimeout(()=>{
            e.style.removeProperty("height"),
            e.style.removeProperty("overflow"),
            e.style.removeProperty("transition-duration"),
            e.style.removeProperty("transition-property")
        }
        , t)
    }
}
customElements.define("toggle-tab", ToggleTab),
document.addEventListener("shopify:block:select", i=>{
    const e = i.target;
    e.classList.contains("toggle") && (e.querySelector(".toggle__title").classList.contains("opened") || e.onClickHandler())
}
),
document.addEventListener("shopify:block:deselect", i=>{
    const e = i.target;
    e.classList.contains("toggle") && e.querySelector(".toggle__title").classList.contains("opened") && e.onClickHandler()
}
);
const isAutoplaySupported = i=>{
    if (typeof i != "function")
        return !1;
    if (sessionStorage.getItem("autoplaySupported"))
        sessionStorage.getItem("autoplaySupported") == "true" ? i(!0) : i(!1);
    else {
        const e = "data:video/mp4;base64,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";
        let t = !1
          , s = document.createElement("video");
        s.setAttribute("playsinline", "playsinline"),
        s.setAttribute("muted", "muted"),
        s.setAttribute("autoplay", "autoplay"),
        s.setAttribute("loop", "loop"),
        s.setAttribute("controls", "controls"),
        s.setAttribute("width", 20),
        s.setAttribute("height", 20),
        s.onplay = ()=>{
            t = !0
        }
        ,
        s.setAttribute("src", e),
        s.style.position = "fixed",
        s.style.top = "-20px",
        s.style.left = "0px",
        s.style.zIndex = "997",
        document.querySelector("body").appendChild(s);
        let r = s.play();
        r !== void 0 && r.then(()=>{
            i(!0),
            sessionStorage.setItem("autoplaySupported", "true"),
            s.remove()
        }
        ).catch(o=>{
            t || o.toString().includes("interact with the document") ? (i(!0),
            sessionStorage.setItem("autoplaySupported", "true")) : (i(!1),
            sessionStorage.setItem("autoplaySupported", "false")),
            s.remove()
        }
        )
    }
}
;
class VideoPopup extends HTMLElement {
    constructor() {
        super(),
        this.querySelector(".video-popup__link").addEventListener("click", e=>{
            e.preventDefault();
            const t = document.createElement("div");
            t.classList.add("video-popup__blackout"),
            this.append(t),
            setTimeout(()=>{
                t.style.opacity = "1"
            }
            , 10),
            this.classList.add("video-opened"),
            this.querySelector(".video-popup__close") && this.querySelector(".video-popup__close").addEventListener("click", s=>{
                this.querySelectorAll("iframe, video").forEach(r=>{
                    r.remove()
                }
                ),
                t.remove(),
                this.classList.remove("video-opened")
            }
            ),
            setTimeout(()=>{
                pauseAllMedia(),
                this.querySelector(".video-popup__container").appendChild(this.querySelector("template").content.firstElementChild.cloneNode(!0)),
                setTimeout(()=>{
                    playMedia(this.closest("[data-video]"))
                }
                , 500)
            }
            , 50)
        }
        )
    }
}
customElements.define("video-popup", VideoPopup);
class VideoBackground extends HTMLElement {
    constructor() {
        super(),
        isAutoplaySupported(e=>{
            if (e) {
                const t = this.querySelector(".video-text__background");
                t && (t.innerHTML = `<video autoplay muted loop playsinline><source type="video/mp4" src="${t.dataset.src}"></video>`,
                t.querySelector("video").play(),
                setTimeout(()=>{
                    t.querySelector("video").style.opacity = "1"
                }
                , 200))
            } else
                this.querySelector(".video-text__background .video-text__image").style.display = "block"
        }
        )
    }
}
customElements.define("video-background", VideoBackground);
function debounce(i, e) {
    let t;
    return (...s)=>{
        clearTimeout(t),
        t = setTimeout(()=>i.apply(this, s), e)
    }
}
KROWN.helpers = {
    formatMoney: function(i, e) {
        typeof i == "string" && (i = i.replace(".", ""));
        let t = "";
        const s = /\{\{\s*(\w+)\s*\}\}/
          , r = e || moneyFormat;
        function o(n, l, a, d) {
            if (a = a || ",",
            d = d || ".",
            isNaN(n) || n === null)
                return 0;
            const h = (n = (n / 100).toFixed(l)).split(".");
            return h[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + a) + (h[1] ? d + h[1] : "")
        }
        switch (r.match(s)[1]) {
        case "amount":
            t = o(i, 2);
            break;
        case "amount_no_decimals":
            t = o(i, 0);
            break;
        case "amount_with_comma_separator":
            t = o(i, 2, ".", ",");
            break;
        case "amount_no_decimals_with_comma_separator":
            t = o(i, 0, ".", ",");
            break;
        case "amount_no_decimals_with_space_separator":
            t = o(i, 0, " ");
            break;
        case "amount_with_apostrophe_separator":
            t = o(i, 2, "'")
        }
        return r.replace(s, t)
    }
};
const getPseudoContent = i=>{
    var e = document.querySelector(i);
    return window.getComputedStyle(e, ":after").getPropertyValue("content")
}
  , pauseAllMedia = ()=>{
    document.querySelectorAll(".product .js-youtube").forEach(i=>{
        i.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*")
    }
    ),
    document.querySelectorAll(".product .js-vimeo").forEach(i=>{
        i.contentWindow.postMessage('{"method":"pause"}', "*")
    }
    ),
    document.querySelectorAll(".product video").forEach(i=>i.pause()),
    document.querySelectorAll(".product product-model").forEach(i=>{
        i.modelViewerUI && i.modelViewerUI.pause()
    }
    )
}
  , playMedia = i=>{
    switch (i.dataset.productMediaType) {
    case "video":
        i.querySelector("video").play();
        break;
    case "external_video-youtube":
        i.querySelector(".js-youtube").contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', "*");
        break;
    case "external_video-vimeo":
        i.querySelector(".js-vimeo").contentWindow.postMessage('{"method":"play"}', "*")
    }
}
  , serializeForm = i=>{
    let e = [];
    return Array.prototype.slice.call(i.elements).forEach(function(t) {
        !t.name || t.disabled || ["file", "reset", "submit", "button"].indexOf(t.type) > -1 || (t.type !== "select-multiple" ? ["checkbox", "radio"].indexOf(t.type) > -1 && !t.checked || e.push(encodeURIComponent(t.name) + "=" + encodeURIComponent(t.value)) : Array.prototype.slice.call(t.options).forEach(function(s) {
            s.selected && e.push(encodeURIComponent(t.name) + "=" + encodeURIComponent(s.value))
        }))
    }),
    e.join("&")
}
  , getJSONP = (i,e)=>{
    var t = "_" + +new Date
      , s = document.createElement("script")
      , r = document.getElementsByTagName("head")[0] || document.documentElement;
    window[t] = function(o) {
        r.removeChild(s),
        e && e(o)
    }
    ,
    s.src = i.replace("callback=?", "callback=" + t),
    r.appendChild(s)
}
  , trueTypeOf = i=>Object.prototype.toString.call(i).slice(8, -1).toLowerCase()
  , htmlEscape = i=>i.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;")
  , reframe = (i,e)=>{
    let t = typeof i == "string" ? document.querySelectorAll(i) : i;
    const s = e || "js-reframe";
    "length"in t || (t = [t]);
    for (let r = 0; r < t.length; r += 1) {
        const o = t[r];
        if (o.className.split(" ").indexOf(s) !== -1 || o.style.width.indexOf("%") > -1)
            continue;
        const n = (o.getAttribute("height") || o.offsetHeight) / (o.getAttribute("width") || o.offsetWidth) * 100
          , l = document.createElement("div");
        l.className = s;
        const a = l.style;
        a.position = "relative",
        a.width = "100%",
        a.paddingTop = n + "%";
        const d = o.style;
        d.position = "absolute",
        d.width = "100%",
        d.height = "100%",
        d.left = "0",
        d.top = "0",
        o.parentNode.insertBefore(l, o),
        o.parentNode.removeChild(o),
        l.appendChild(o)
    }
}
;
window.KEYCODES = {
    TAB: 9,
    ESC: 27,
    DOWN: 40,
    RIGHT: 39,
    UP: 38,
    LEFT: 37,
    RETURN: 13
};
class MainSidebar extends HTMLElement {
    constructor() {
        if (super(),
        this.SCROLL_EVENT = a=>{
            this.offsetHeight > window.innerHeight ? this.style.transform = "translate3d(0," + -1 * window.scrollY + "px, 0)" : this.style.transform = "translate3d(0," + -1 * (this.offsetHeight - window.innerHeight) + "px, 0)"
        }
        ,
        this.addEventListener("scroll", this.SCROLL_EVENT, {
            passive: !0
        }),
        this.RESIZE_EVENT = debounce(()=>{
            this.offsetHeight > window.innerHeight ? this.SCROLL_EVENT() : this.style.transform = "translate3d(0, 0, 0)",
            this.setSidebarHeight()
        }
        , 300),
        this.addEventListener("resize", this.RESIZE_EVENT, {
            passive: !0
        }),
        setTimeout(()=>{
            this.RESIZE_EVENT()
        }
        , 310),
        !document.body.classList.contains("template-cart") && KROWN.settings.cart_action == "overlay") {
            const a = document.querySelector(".sidebar__cart");
            document.querySelector(".sidebar__cart-handle") && document.querySelector(".sidebar__cart-handle").addEventListener("click", d=>{
                d.preventDefault(),
                a.show()
            }
            ),
            document.querySelector(".sidebar__cart-handle") && document.querySelector(".sidebar__cart-handle").addEventListener("keyup", d=>{
                d.keyCode == window.KEYCODES.RETURN && setTimeout(()=>{
                    document.querySelector(".sidebar__cart .sidebar__cart-close").focus()
                }
                , 100)
            }
            )
        }
        const e = document.querySelector(".sidebar__search");
        KROWN.settings.predictive_search_enabled == "false" ? document.querySelector(".sidebar__search-handle") && document.querySelector(".sidebar__search-handle").addEventListener("click", a=>{
            a.preventDefault(),
            e.classList.contains("opened") ? e.classList.remove("opened") : (e.classList.add("opened"),
            document.querySelector('.sidebar__search input[type="search"]').setAttribute("placeholder", document.querySelector('.sidebar__search input[type="search"]').dataset.responsivePlaceholder),
            setTimeout(()=>{
                document.querySelector('.sidebar__search input[type="search"]').focus()
            }
            , 100))
        }
        ) : (this.closePredictiveSearch = (()=>{
            document.querySelector(".sidebar").classList.remove("no-transforms"),
            e.classList.remove("open-search"),
            e.classList.remove("opened"),
            this.querySelector("[data-search-results]").classList.remove("show"),
            this.querySelector("[data-search-link]").classList.remove("show"),
            document.body.classList.remove("overflow-hidden"),
            document.querySelector(".cart-overlay-background").classList.remove("show"),
            document.querySelector(".cart-overlay-background").removeEventListener("click", this.closePredictiveSearch)
        }
        ).bind(this),
        document.querySelector(".sidebar__search-handle") && document.querySelector(".sidebar__search-handle").addEventListener("click", a=>{
            window.getComputedStyle(e, ":after").content.includes("predictive-mobile") && (a.preventDefault(),
            e.classList.contains("opened") ? e.hide() : e.show())
        }
        ),
        this.querySelector('input[type="search"]') && this.querySelector('input[type="search"]').addEventListener("click", a=>{
            e.classList.contains("open-search") || (this.setSidebarHeight(),
            document.querySelector(".sidebar").classList.add("no-transforms"),
            e.classList.add("open-search"),
            e.classList.add("opened"),
            this.querySelector("[data-search-results]").classList.add("show"),
            document.body.classList.add("overflow-hidden"),
            document.querySelector(".cart-overlay-background").classList.add("show"),
            document.querySelector(".cart-overlay-background").addEventListener("click", this.closePredictiveSearch))
        }
        ),
        this.querySelector(".sidebar__search-close") && this.querySelector(".sidebar__search-close").addEventListener("click", a=>{
            window.getComputedStyle(e, ":after").content.includes("predictive-mobile") || this.closePredictiveSearch()
        }
        ),
        document.addEventListener("keydown", a=>{
            if (a.keyCode == window.KEYCODES.ESC) {
                const d = window.getComputedStyle(e, ":after").content;
                e.classList.contains("open-search") && !d.includes("predictive-mobile") && this.closePredictiveSearch()
            }
        }
        ));
        const t = document.querySelector(".sidebar__menus");
        document.querySelector(".sidebar__menu-handle") && document.querySelector(".sidebar__menu-handle").addEventListener("click", a=>{
            a.preventDefault(),
            t.classList.remove("kill-overflow"),
            t.classList.contains("opened") ? t.hide() : t.show()
        }
        );
        let s = 0;
        document.querySelectorAll(".sidebar__menus .sidebar__menu .has-submenu > a").forEach(a=>{
            a.addEventListener("click", d=>{
                window.innerWidth <= 948 && (d.preventDefault(),
                d.stopPropagation(),
                t.classList.add("kill-overflow"),
                t.scrollTop = 0,
                s = a.parentNode.classList.contains("has-second-submenu") ? 2 : 1,
                a.parentNode.classList.add("open-submenu"),
                a.parentNode.parentNode.classList.add("opened-submenu"),
                a.closest(".sidebar__menus").classList.add("opened-submenus"),
                a.parentNode.parentNode.parentNode.classList.contains("primary-menu") ? a.parentNode.parentNode.parentNode.nextElementSibling.classList.add("opened-other-submenu") : a.parentNode.parentNode.parentNode.previousElementSibling.classList.add("opened-other-submenu"))
            }
            )
        }
        ),
        document.querySelector(".sidebar__menus-back").addEventListener("click", a=>{
            s == 1 ? (s = 0,
            t.classList.remove("opened-submenus"),
            t.querySelector("nav.opened-other-submenu").classList.remove("opened-other-submenu"),
            t.querySelector(".opened-submenu").classList.remove("opened-submenu"),
            t.querySelector(".open-submenu").classList.remove("open-submenu"),
            t.classList.remove("kill-overflow")) : s == 2 && (s = 1,
            document.querySelector(".has-second-submenu.open-submenu").parentNode.classList.remove("opened-submenu"),
            document.querySelector(".has-second-submenu.open-submenu").classList.remove("open-submenu"))
        }
        ),
        this.sidebarParentFLAG = !1,
        this.sidebarSeconds = document.querySelector(".sidebar__seconds"),
        this.sidebarSecondsDOM = document.querySelector(".sidebar__seconds .sidebar__menu"),
        this.sidebarSecondsFLAG = !1,
        this.sidebarThirds = document.querySelector(".sidebar__thirds"),
        this.sidebarThirdsDOM = document.querySelector(".sidebar__thirds .sidebar__menu"),
        this.sidebarThirdsFLAG = !1,
        document.querySelectorAll(".has-first-submenu > a").forEach(a=>{
            a.addEventListener("touchstart", d=>{
                window.innerWidth > 948 && (d.preventDefault(),
                a.parentNode.querySelectorAll("a")[0].style.pointerEvents = "none",
                this.onMouseEnterHandlerFirst({
                    currentTarget: a.parentNode,
                    preventDefault: ()=>{}
                }))
            }
            , {
                passive: !0
            })
        }
        ),
        document.querySelectorAll(".has-first-submenu").forEach(a=>{
            a.addEventListener("mouseenter", this.onMouseEnterHandlerFirst.bind(this)),
            a.addEventListener("mouseleave", this.onMouseLeaveHandlerFirst.bind(this))
        }
        ),
        this.sidebarSeconds.addEventListener("mouseenter", ()=>{
            document.body.classList.add("show-overlay"),
            this.sidebarSeconds.classList.add("opened"),
            this.sidebarSeconds.querySelector(".sidebar__submenu--first") && this.sidebarSeconds.querySelector(".sidebar__submenu--first").classList.add("submenu-opened")
        }
        ),
        this.sidebarSeconds.addEventListener("mouseleave", this.onMouseLeaveHandlerFirst.bind(this)),
        this.sidebarThirds.addEventListener("mouseenter", ()=>{
            document.body.classList.add("show-overlay"),
            this.sidebarThirds.classList.add("opened"),
            this.sidebarSeconds.classList.add("opened"),
            this.sidebarSeconds.querySelector(".sidebar__submenu--first").classList.add("submenu-opened"),
            this.sidebarThirds.querySelector(".sidebar__submenu--second").classList.add("submenu-opened")
        }
        ),
        this.sidebarThirds.addEventListener("mouseleave", ()=>{
            this.onMouseLeaveHandlerFirst(),
            this.onMouseLeaveHandlerSecond()
        }
        );
        let r = document.activeElement
          , o = null
          , n = null
          , l = !1;
        document.addEventListener("keyup", a=>{
            a.keyCode == window.KEYCODES.TAB && (document.activeElement.classList.contains("parent-has-submenu") ? (document.activeElement.parentNode.classList.contains("has-first-submenu") ? this.onMouseEnterHandlerFirst({
                currentTarget: document.activeElement.parentNode,
                preventDefault: ()=>{}
            }) : document.activeElement.parentNode.classList.contains("has-second-submenu") && this.onMouseEnterHandlerSecond({
                currentTarget: document.activeElement.parentNode,
                preventDefault: ()=>{}
            }),
            document.activeElement.classList.contains("sub-menu__link-second") ? document.activeElement.classList.contains("sub-menu__last-second") ? (n = o,
            l = !0) : n = document.activeElement.parentNode.nextElementSibling.querySelector(":scope > a") : document.activeElement.parentNode.nextElementSibling ? o = document.activeElement.parentNode.nextElementSibling.querySelector(":scope > a") : document.activeElement.dataset.type == "primary" ? o = document.querySelector(".secondary-menu").querySelectorAll("a")[0] : document.activeElement.dataset.type == "secondary" && (o = document.querySelector(".accounts-menu") ? document.querySelector(".accounts-menu").querySelectorAll("a")[0] : document.querySelector(".sidebar .localization-form__item") ? document.querySelectorAll(".sidebar .localization-form__item")[0].querySelectorAll("button")[0] : document.querySelector(".sidebar .sidebar__search form"))) : r.classList.contains("sub-menu__last-second") ? !r.classList.contains("parent-has-submenu") || r.classList.contains("ran-over") ? (o && o.focus(),
            this.onMouseLeaveHandlerFirst()) : r.classList.add("ran-over") : r.classList.contains("sub-menu__last-third") && (n && n.focus(),
            this.onMouseLeaveHandlerSecond(),
            document.activeElement.classList.contains("sub-menu__last-second") && document.activeElement.classList.contains("ran-over") ? (this.onMouseLeaveHandlerFirst(),
            this.onMouseLeaveHandlerSecond(),
            o && o.focus()) : document.activeElement.parentNode.classList.contains("has-second-submenu") && (this.onMouseEnterHandlerSecond({
                currentTarget: document.activeElement.parentNode,
                preventDefault: ()=>{}
            }),
            document.activeElement.classList.contains("sub-menu__last-second") || (n = document.activeElement.parentNode.nextElementSibling.querySelector(":scope > a"))),
            l && (l = !1,
            this.onMouseLeaveHandlerFirst())),
            r = document.activeElement)
        }
        ),
        document.addEventListener("keydown", a=>{
            a.keyCode == window.KEYCODES.TAB ? r.classList.contains("parent-has-submenu") && (a.preventDefault(),
            this.sidebarSeconds.querySelectorAll("a")[0].focus(),
            r.classList.contains("sub-menu__link-second") && this.sidebarThirds.querySelectorAll("a")[0].focus()) : a.keyCode == window.KEYCODES.ESC && (this.sidebarSecondsFLAG && this.onMouseLeaveHandlerFirst(),
            this.sidebarThirdsFLAG && this.onMouseLeaveHandlerSecond())
        }
        )
    }
    onMouseEnterHandlerFirst(e) {
        if (window.innerWidth > 948) {
            e.preventDefault(),
            document.body.classList.add("show-overlay"),
            this.sidebarSeconds.classList.add("opened"),
            this.sidebarSecondsFLAG = !0;
            let t = document.createElement("div");
            t.classList.add("clone"),
            t.innerHTML = e.currentTarget.querySelector(":scope > .sidebar__submenu").outerHTML,
            t = t.querySelector(":scope > div"),
            this.sidebarSecondsDOM.querySelector(".sidebar__submenu") && this.sidebarSecondsDOM.querySelector(".sidebar__submenu").dataset.handle == t.dataset.handle || (this.sidebarSecondsDOM.innerHTML = t.outerHTML),
            this.sidebarSecondsDOM.querySelector(":scope > .sidebar__submenu .sub-menu").style.paddingTop = e.currentTarget.getBoundingClientRect().top + "px",
            setTimeout(()=>{
                this.sidebarSecondsDOM.querySelector(":scope > .sidebar__submenu").classList.add("submenu-opened")
            }
            , 10),
            this.sidebarSecondsDOM.querySelectorAll(".has-second-submenu").forEach(s=>{
                s.addEventListener("touchstart", r=>{
                    r.preventDefault(),
                    s.parentNode.querySelectorAll("a")[0].style.pointerEvents = "none",
                    this.onMouseEnterHandlerSecond({
                        currentTarget: s,
                        preventDefault: ()=>{}
                    }),
                    this.sidebarThirdsFLAG && this.onMouseLeaveHandlerSecond()
                }
                , {
                    passive: !0
                }),
                s.addEventListener("mouseenter", this.onMouseEnterHandlerSecond.bind(this)),
                s.addEventListener("mouseleave", ()=>{
                    this.sidebarThirdsFLAG && this.onMouseLeaveHandlerSecond()
                }
                )
            }
            ),
            e.currentTarget.addEventListener("mouseleave", this.onMouseLeaveHandlerSecond.bind(this))
        }
    }
    onMouseEnterHandlerSecond(e) {
        e.preventDefault(),
        this.sidebarThirds.classList.add("opened"),
        this.sidebarThirdsFLAG = !0;
        let t = document.createElement("div");
        t.classList.add("clone"),
        t.innerHTML = e.currentTarget.querySelector(":scope > .sidebar__submenu").outerHTML,
        t = t.querySelector(":scope > div"),
        (!this.sidebarThirdsDOM.querySelector(".sidebar__submenu") || this.sidebarThirdsDOM.querySelector(".sidebar__submenu") && this.sidebarThirdsDOM.querySelector(".sidebar__submenu").dataset.handle != t.dataset.handle) && (this.sidebarThirdsDOM.innerHTML = t.outerHTML),
        this.sidebarThirdsDOM.querySelector(":scope > .sidebar__submenu .sub-menu").style.paddingTop = e.currentTarget.getBoundingClientRect().top + "px",
        setTimeout(()=>{
            this.sidebarThirdsDOM.querySelector(":scope > .sidebar__submenu").classList.add("submenu-opened")
        }
        , 10)
    }
    onMouseLeaveHandlerFirst() {
        this.sidebarSeconds.classList.remove("opened"),
        this.sidebarSeconds.querySelector(".submenu-opened") && this.sidebarSeconds.querySelector(".submenu-opened").classList.remove("submenu-opened"),
        document.body.classList.remove("show-overlay"),
        this.sidebarSecondsFLAG = !1
    }
    onMouseLeaveHandlerSecond() {
        this.sidebarThirds.classList.remove("opened"),
        this.sidebarThirds.querySelector(".submenu-opened") && this.sidebarThirds.querySelector(".submenu-opened").classList.remove("submenu-opened"),
        this.sidebarThirdsFLAG = !1
    }
    setSidebarHeight() {
        document.querySelectorAll(".sidebar__cart, .sidebar__cart .cart, .sidebar__search, .collection__filters, .collection__filters .filters").forEach(e=>{
            e.style.height = window.innerHeight + "px"
        }
        ),
        document.querySelector(".sidebar__menus").style.height = window.innerHeight + "px",
        document.querySelector(".sidebar__search.predictive-search .sidebar__search-results") && (document.querySelector(".sidebar__search.predictive-search .sidebar__search-results").style.maxHeight = window.innerHeight - 170 + "px")
    }
}
customElements.define("main-sidebar", MainSidebar);
let overlay = document.createElement("span");
overlay.className = "cart-overlay-background",
overlay.addEventListener("click", ()=>{
    document.querySelector("sidebar-drawer.opened").hide()
}
),
document.body.append(overlay),
overlay = document.createElement("span"),
overlay.className = "sidebar-overlay-background",
overlay.addEventListener("click", ()=>{
    document.querySelector("sidebar-drawer.opened").hide()
}
),
document.body.append(overlay);
class SidebarDrawer extends HTMLElement {
    constructor() {
        super(),
        this.querySelector("[data-close]").addEventListener("click", ()=>{
            this.hide()
        }
        ),
        document.addEventListener("keydown", e=>{
            if (e.keyCode == window.KEYCODES.ESC) {
                const t = document.querySelector("sidebar-drawer.opened");
                t && t.hide()
            }
        }
        ),
        this.setAttribute("style", "")
    }
    show() {
        this.opened = !0,
        this.classList.add("opened"),
        document.body.classList.add("overflow-hidden"),
        this.dataset.overlay == "sidebar" ? document.querySelector(".sidebar-overlay-background").classList.add("show") : this.dataset.overlay == "cart" && document.querySelector(".cart-overlay-background").classList.add("show"),
        document.querySelectorAll(".sidebar__cart, .sidebar__cart .cart, .sidebar__search, .collection__filters, .collection__filters .filters").forEach(e=>{
            e.style.height = window.innerHeight + "px"
        }
        ),
        document.querySelector(".sidebar__menus").style.height = window.innerHeight + "px",
        document.querySelector(".sidebar__search.predictive-search .sidebar__search-results") && (document.querySelector(".sidebar__search.predictive-search .sidebar__search-results").style.maxHeight = window.innerHeight - 170 + "px"),
        this._mountA11YHelper()
    }
    hide() {
        this.opened = !1,
        this.classList.remove("opened"),
        document.body.classList.remove("overflow-hidden"),
        this.dataset.overlay == "sidebar" ? document.querySelector(".sidebar-overlay-background").classList.remove("show") : this.dataset.overlay == "cart" && document.querySelector(".cart-overlay-background").classList.remove("show"),
        this._unmountA11YHelper()
    }
    _mountA11YHelper(e) {
        let t = e || this.querySelectorAll('[tabindex="0"], button, [href], input:not([type="hidden"]), select, textarea, .regular-select-cover')
          , s = t[0]
          , r = t[t.length - 1];
        this.classList.contains("sidebar__cart") && !this.querySelector(".cart__form").classList.contains("cart--empty") && (r = t[t.length - 2]),
        this.A11Y_TAB_EVENT = ((o,n,l)=>{
            (l.key === "Tab" || l.keyCode === window.KEYCODES.TAB) && (l.shiftKey ? document.activeElement === o && (n.focus(),
            l.preventDefault()) : document.activeElement === n && (o.focus(),
            l.preventDefault()))
        }
        ).bind(this, s, r),
        this.addEventListener("keydown", this.A11Y_TAB_EVENT)
    }
    _unmountA11YHelper(e) {
        this.removeEventListener("keydown", this.A11Y_TAB_EVENT)
    }
}
customElements.define("sidebar-drawer", SidebarDrawer);
class ProductModel extends HTMLElement {
    constructor() {
        super(),
        Shopify.loadFeatures([{
            name: "model-viewer-ui",
            version: "1.0",
            onLoad: this.setupModelViewerUI.bind(this)
        }])
    }
    setupModelViewerUI(e) {
        if (e)
            return;
        this.modelViewerUI = new Shopify.ModelViewerUI(this.querySelector("model-viewer"));
        const t = this.modelViewerUI.viewer;
        t.addEventListener("shopify_model_viewer_ui_toggle_play", ()=>{
            t.closest(".css-slider-holder") && t.closest(".css-slider-holder").classList.add("css-slider--disable-dragging")
        }
        ),
        t.addEventListener("shopify_model_viewer_ui_toggle_pause", ()=>{
            t.closest(".css-slider-holder") && t.closest(".css-slider-holder").classList.remove("css-slider--disable-dragging")
        }
        ),
        t.closest(".product-gallery__item") && t.closest(".product-gallery__item").dataset.index == "0" && t.closest(".css-slider-holder") && t.closest(".css-slider-holder").classList.add("css-slider--disable-dragging")
    }
}
customElements.define("product-model", ProductModel),
window.ProductModel = {
    loadShopifyXR() {
        Shopify.loadFeatures([{
            name: "shopify-xr",
            version: "1.0",
            onLoad: this.setupShopifyXR.bind(this)
        }])
    },
    setupShopifyXR(i) {
        i || (window.ShopifyXR ? (document.querySelectorAll('[id^="ProductJSON-"]').forEach(e=>{
            window.ShopifyXR.addModels(JSON.parse(e.textContent)),
            e.remove()
        }
        ),
        window.ShopifyXR.setupXRElements()) : document.addEventListener("shopify_xr_initialized", ()=>this.setupShopifyXR()))
    }
};
class ProductQuantity extends HTMLElement {
    constructor() {
        super();
        const e = this.querySelector(".quantity__selector")
          , t = this.querySelector(".quantity__minus")
          , s = this.querySelector(".quantity__plus")
          , r = e.getAttribute("min") ? parseInt(e.getAttribute("min")) : 1
          , o = e.getAttribute("max") ? parseInt(e.getAttribute("max")) : 999;
        parseInt(e.value) - 1 < r && t.classList.add("disabled"),
        parseInt(e.value) + 1 > o && s.classList.add("disabled"),
        t.addEventListener("click", n=>{
            if (n.preventDefault(),
            !t.classList.contains("disabled")) {
                const l = parseInt(e.value);
                l - 1 >= r && (e.value = l - 1,
                s.classList.remove("disabled")),
                l - 1 <= r && t.classList.add("disabled")
            }
        }
        ),
        s.addEventListener("click", n=>{
            if (n.preventDefault(),
            !s.classList.contains("disabled")) {
                const l = parseInt(e.value);
                l + 1 <= o && (e.value = l + 1,
                t.classList.remove("disabled")),
                l + 1 >= o && s.classList.add("disabled")
            }
        }
        )
    }
}
customElements.define("product-quantity", ProductQuantity);
class SharePopup extends HTMLElement {
    constructor() {
        super(),
        basicLightbox.create(this.querySelector("#share-popup"), {
            trigger: this.querySelector(".share-link"),
            focus: "a"
        })
    }
}
customElements.define("share-popup", SharePopup);
class CollectionFiltersMobileHandle extends HTMLElement {
    constructor() {
        super(),
        this.querySelector("button").addEventListener("click", ()=>{
            document.querySelector(".collection__filters").show()
        }
        )
    }
}
customElements.define("collection-filters-mobile-handle", CollectionFiltersMobileHandle);
class ProductDescription extends HTMLElement {
    constructor() {
        super(),
        this.init()
    }
    init() {
        this.description = this.querySelector(".product__description"),
        this.description.classList.contains("truncated") && (this.descriptionInner = this.description.querySelector(".product__description-inner"),
        this.descriptionInner.offsetHeight - 10 > this.description.offsetHeight && (this.descriptionTrigger = document.createElement("a"),
        this.descriptionTrigger.classList.add("truncated__trigger"),
        this.descriptionTrigger.setAttribute("tabindex", "0"),
        this.descriptionTrigger.setAttribute("aria-controls", this.descriptionInner.id),
        this.descriptionTrigger.setAttribute("aria-expanded", !1),
        this.descriptionTrigger.textContent = KROWN.settings.locales.product_more_description_label,
        this.description.after(this.descriptionTrigger),
        this.descriptionTrigger.addEventListener("click", this.onClickHandler.bind(this)),
        this.descriptionTrigger.addEventListener("keydown", e=>{
            e.keyCode == window.KEYCODES.RETURN && this.onClickHandler(e)
        }
        )))
    }
    onClickHandler(e) {
        e.preventDefault(),
        this.description.classList.contains("truncated--show") ? (this.description.classList.remove("truncated--show"),
        this.description.setAttribute("style", ""),
        this.descriptionTrigger.textContent = KROWN.settings.locales.product_more_description_label,
        this.descriptionTrigger.setAttribute("aria-expanded", !1)) : (this.description.classList.add("truncated--show"),
        this.description.style.maxHeight = this.descriptionInner.offsetHeight + "px",
        this.descriptionTrigger.textContent = KROWN.settings.locales.product_less_description_label,
        this.descriptionTrigger.setAttribute("aria-expanded", !0),
        this.descriptionInner.setAttribute("tabIndex", "0"))
    }
}
customElements.define("product-description", ProductDescription),
document.addEventListener("shopify:section:load", i=>{
    i.target.classList.contains("main-product") && i.target.querySelector("product-description") && i.target.querySelector("product-description").init()
}
);
class ProductPage extends HTMLElement {
    constructor() {
        super(),
        this.productGallery = this.querySelector(".product-gallery"),
        this.productSlider = this.querySelector("css-slider"),
        this.querySelector(".product-gallery__thumbnails .thumbnail") && (this.querySelectorAll(".product-gallery__thumbnails .thumbnail").forEach((s,r)=>{
            r == 0 && s.classList.add("active"),
            s.addEventListener("click", o=>{
                this.productSlider.sliderEnabled ? this.productSlider.changeSlide(o.currentTarget.dataset.index) : (window.scrollTo({
                    top: this.productGallery.querySelector(`.product-gallery__item[data-index="${o.currentTarget.dataset.index}"]`).offsetTop + this.offsetTop,
                    behavior: "smooth"
                }),
                this.thumbnailNavigationHelper(o.currentTarget.dataset.index)),
                pauseAllMedia(),
                playMedia(this.productGallery.querySelector(`.product-gallery__item[data-index="${o.currentTarget.dataset.index}"]`))
            }
            )
        }
        ),
        this.productSlider.addEventListener("change", s=>{
            this.thumbnailNavigationHelper(s.target.index)
        }
        )),
        this.productSlider.addEventListener("navigation", s=>{
            playMedia(this.productGallery.querySelector(`.product-gallery__item[data-index="${s.target.index}"]`))
        }
        ),
        this.productSlider.addEventListener("change", s=>{
            this.productGallery.querySelector(`.product-gallery__item[data-index="${s.target.index}"]`).dataset.productMediaType == "model" && this.xrButton && this.xrButton.setAttribute("data-shopify-model3d-id", this.productGallery.querySelector(`.product-gallery__item[data-index="${s.target.index}"]`).dataset.mediaId),
            pauseAllMedia(),
            this.thumbnailNavigationHelper(s.target.index)
        }
        );
        const e = this.querySelector("product-variants");
        if (e && (e.addEventListener("VARIANT_CHANGE", this.onVariantChangeHandler.bind(this)),
        this.onVariantChangeHandler({
            target: e
        })),
        !document.body.classList.contains("template-cart") && KROWN.settings.cart_action == "overlay") {
            let s = !1;
            this.querySelector(".product__add-to-cart") && this.querySelector(".product__add-to-cart").addEventListener("keyup", r=>{
                r.keyCode == window.KEYCODES.RETURN && (s = !0)
            }
            ),
            this.querySelector(".product__form") && this.querySelector(".product__form").addEventListener("add-to-cart", ()=>{
                window.preloadImages(document.querySelector(".sidebar__cart")),
                document.querySelector(".sidebar__cart").show(),
                s && setTimeout(()=>{
                    document.querySelector(".sidebar__cart .sidebar__cart-close").focus()
                }
                , 200)
            }
            )
        }
        if (this.GALLERY_RESIZE_EVENT = debounce(()=>{
            ProductGalleryResizeHelper(this.productGallery)
        }
        , 100),
        window.addEventListener("resize", this.GALLERY_RESIZE_EVENT, {
            passive: !0
        }),
        this.productGallery.classList.contains("product-gallery--scroll")) {
            this.productGalleryNavigation = this.querySelector(".product-gallery__thumbnails"),
            this.productGalleryNavigationItem = this.querySelectorAll(".product-gallery__thumbnails .thumbnail");
            const s = [...this.productGallery.querySelectorAll(".product-gallery__item")].reverse();
            this.GALLERY_NAVIGATION_SCROLL = ()=>{
                if (!this.productGallery.querySelector("css-slider").sliderEnabled && window.innerWidth > 1023) {
                    for (const o of s) {
                        const n = o.getBoundingClientRect().top;
                        if (n < window.innerHeight / 2 && n > -window.innerHeight / 2) {
                            this.productGalleryNavigationItem.forEach(l=>l.classList.remove("active")),
                            this.productGalleryNavigationItem[o.dataset.index].classList.add("active");
                            break
                        }
                    }
                    const r = this.productGallery.getBoundingClientRect().top;
                    -1 * (r - window.innerHeight) > this.productGallery.offsetHeight ? this.productGalleryNavigation.classList.add("scroll") : r > 0 ? (this.productGalleryNavigation.classList.add("scroll-up"),
                    this.productGalleryNavigation.classList.add("scroll")) : -1 * (r - window.innerHeight) < this.productGallery.offsetHeight && (this.productGalleryNavigation.classList.remove("scroll"),
                    this.productGalleryNavigation.classList.remove("scroll-up"))
                }
            }
            ,
            window.addEventListener("scroll", this.GALLERY_NAVIGATION_SCROLL, {
                passive: !0
            }),
            this.GALLERY_NAVIGATION_SCROLL()
        }
        this.querySelectorAll("product-model") && (window.ProductModel.loadShopifyXR(),
        this.xrButton = this.querySelector(".product-gallery__view-in-space"));
        const t = this.querySelector(".product__add-to-cart");
        t && (t.classList.contains("disabled") ? this.querySelector("product-form").classList.add("disable-buy-button") : this.querySelector("product-form").classList.remove("disable-buy-button"),
        new MutationObserver(s=>{
            for (const r of s)
                t.classList.contains("disabled") ? this.querySelector("product-form").classList.add("disable-buy-button") : this.querySelector("product-form").classList.remove("disable-buy-button")
        }
        ).observe(t, {
            attributes: !0,
            childList: !1,
            subtree: !1
        }))
    }
    thumbnailNavigationHelper(e=0) {
        this.querySelectorAll(".product-gallery__thumbnails .thumbnail").forEach((t,s)=>{
            s == e ? t.classList.add("active") : t.classList.remove("active")
        }
        )
    }
    onVariantChangeHandler(e) {
        let t = e.target.currentVariant;
        if (t && t.featured_media != null) {
            let s = this.productGallery.querySelector('.product-gallery__item[data-media-id="' + t.featured_media.id + '"]');
            s && (this.productGallery.classList.contains("product-gallery--slider") || this.productGallery.classList.contains("product-gallery--scroll") && window.innerWidth < 1024 ? this.productGallery.querySelector("css-slider").sliderEnabled && this.productGallery.querySelector("css-slider").changeSlide(s.dataset.index) : window.scrollTo({
                top: s.offsetTop,
                behavior: "smooth"
            }))
        }
    }
}
customElements.define("product-page", ProductPage);
class ProductReviews {
    constructor(e) {
        const t = new MutationObserver((s,r)=>{
            for (const o of s)
                o.addedNodes.length > 0 && o.addedNodes.forEach(n=>{
                    n.tagName == "DIV" && n.classList.contains("spr-container") && (this.init(n),
                    r.disconnect())
                }
                )
        }
        );
        e.querySelector(".spr-review") ? this.init(e.querySelector(".spr-container")) : t.observe(e, {
            childList: !0
        })
    }
    init(e) {
        if (e.querySelector(".spr-review")) {
            const r = e.querySelector(".spr-reviews")
              , o = document.createElement("div");
            o.innerHTML = `<css-slider
	      class="spr-reviews css-slider--simple-dots" 
	      data-options='{
	        "selector": ".spr-review",
	        "navigation": false,
	        "groupCells": true,
	        "autoHeight": ${window.innerWidth < 520}
	      }'>${r.innerHTML}</div>`,
            r.remove(),
            e.querySelector(".spr-content").append(o);
            const n = o.querySelector("css-slider");
            setTimeout(()=>{
                n.resetSlider(!0)
            }
            , 100);
            const l = new IntersectionObserver((a,d)=>{
                a.forEach(h=>{
                    if (h.isIntersecting && h.target.querySelector(".spr-pagination-next a")) {
                        const g = h.target.querySelector(".spr-pagination-next a");
                        getJSONP(`${SPR.api_url}/reviews?page=${g.dataset.page}&product_id=${g.dataset.productId}&shop=${window.location.hostname}&callback=?`, S=>{
                            g.closest(".spr-pagination").remove();
                            const f = new DOMParser().parseFromString(S.reviews, "text/html");
                            f.querySelectorAll(".spr-review, .spr-pagination") && f.querySelectorAll(".spr-review, .spr-pagination").forEach(v=>{
                                n.querySelector(".css-slider-container").append(v),
                                v.classList.contains("spr-pagination") && (l.disconnect(),
                                l.observe(v))
                            }
                            ),
                            n.afterAppend(),
                            n.resetSlider(!0, !1)
                        }
                        )
                    }
                }
                )
            }
            ,{
                threshold: 1
            });
            o.querySelector(".spr-pagination") && l.observe(o.querySelector(".spr-pagination"))
        }
        const t = document.createElement("div");
        t.id = "spr-form-modal",
        t.innerHTML = `<div id="spr-form" class="spr-form-holder address-popup">
      <div class="basicLightboxClose" tabindex="0">\xD7</div>
    </div>`,
        document.querySelector(".spr-summary-actions-newreview").setAttribute("onclick", "");
        const s = basicLightbox.create(t, {
            trigger: document.querySelector(".spr-summary-actions-newreview"),
            focus: 'input[type="text"]'
        });
        s.element().querySelector(".spr-form-holder").prepend(e.querySelector(".spr-form")),
        s.element().querySelector(".spr-form").style.display = "block"
    }
}
document.getElementById("shopify-product-reviews") && new ProductReviews(document.getElementById("shopify-product-reviews")),
document.addEventListener("shopify:section:load", i=>{
    i.target.classList.contains("mount-product-gallery") && ProductGalleryResizeHelper(i.target.querySelector(".product-gallery"))
}
);
class GalleryZoom extends HTMLElement {
    constructor() {
        super();
        const e = basicLightbox.create(`<img data-src="${this.dataset.src}" alt="" />`);
        this.addEventListener("click", t=>{
            t.preventDefault();
            const s = e.element().querySelector("img");
            s.setAttribute("src", s.dataset.src),
            e.show()
        }
        )
    }
}
customElements.define("gallery-zoom", GalleryZoom);
class ImageSlideshow extends CSSSlider {
    constructor() {
        if (super(),
        this.slides = this.querySelectorAll(".slide"),
        this.images = this.querySelectorAll("img"),
        this.overlays = this.querySelectorAll(".slide__overlay"),
        this.texts = this.querySelectorAll(".slide__text"),
        this.classList.contains("slider--scroll")) {
            const e = document.createElement("div");
            e.classList.add("slider__dots"),
            this.append(e),
            this.images.forEach((t,s)=>{
                const r = document.createElement("div");
                r.classList.add("dot"),
                e.append(r),
                r.addEventListener("click", ()=>{
                    window.scrollTo({
                        top: this.slides[s].offsetTop,
                        behavior: "smooth"
                    })
                }
                ),
                s == 0 && r.classList.add("active")
            }
            ),
            this.sliderDot = this.querySelectorAll(".slider__dots .dot"),
            this.sliderDots = this.querySelector(".slider__dots"),
            this.onScrollHandler = (()=>{
                var t = this.offsetTop
                  , s = window.scrollY
                  , r = window.innerHeight;
                s >= t && s + r <= t + this.offsetHeight ? this.images.forEach((o,n)=>{
                    const l = (s - t - r * n) / 2;
                    Math.abs(l) <= r / 2 && this.scrollTransform(l, this.images[n], this.overlays[n], this.texts[n]),
                    s >= r * n + t - r / 2 && !this.sliderDot[n].classList.contains("active") && (this.sliderDots.querySelector(".active").classList.remove("active"),
                    this.sliderDot[n].classList.add("active"))
                }
                ) : s < t ? this.scrollTransform(0, this.images[0], this.overlays[0], this.texts[0]) : s + r > t + this.offsetHeight && this.scrollTransform(0, this.images[this.images.length - 1], this.overlays[this.overlays.length - 1], this.texts[this.texts.length - 1]),
                this.sliderDots.classList.contains("in-view") && (s + r > t + this.offsetHeight || s < t) ? (this.sliderDots.classList.remove("in-view"),
                s < t ? this.sliderDots.classList.remove("in-bottom") : s + r > t && this.sliderDots.classList.add("in-bottom")) : !this.sliderDots.classList.contains("in-view") && s >= t && s + r <= t + this.offsetHeight && this.sliderDots.classList.add("in-view")
            }
            ).bind(this),
            window.addEventListener("scroll", this.onScrollHandler, {
                passive: !0
            }),
            this.onScrollHandler(),
            this.addEventListener("ready", ()=>{
                this.images.forEach((t,s)=>{
                    this.scrollTransform(0, this.images[s], this.overlays[s], this.texts[s], !0)
                }
                )
            }
            )
        }
        this.onResizeHandler = (()=>{
            this.classList.contains("slider--scroll") && this.onScrollHandler(),
            window.innerWidth < 948 && this.classList.contains("slider--mobile-js-height") && (this.classList.contains("slider--horizontal") || this.classList.contains("slider--horizontal-mobile-true")) && (this.style.height = document.documentElement.clientHeight - this.dataset.navigationPadding + "px")
        }
        ).bind(this),
        this.onResizeHandler(),
        (this.classList.contains("slider--horizontal") || this.classList.contains("slider--horizontal-mobile-true")) && ("scrollBehavior"in document.documentElement.style || document.body.classList.contains("touch")) && this.addEventListener("scroll", ()=>{
            const e = -this.element.scrollLeft;
            this.slides.forEach((t,s)=>{
                const r = this.images[s];
                if (r) {
                    const o = t.offsetLeft;
                    r.style.transform = `translateX(${-1 * (o + e) / 3}px)`,
                    this.texts[s].style.transform = `translateX${(o + e) / 8}px)`,
                    this.overlays[s].style.opacity = "" + -1 * (o + e) / 10 / 100
                }
            }
            )
        }
        )
    }
    scrollTransform(e, t, s, r, o=!1) {
        t && (o || document.body.classList.contains("no-touch") && window.innerWidth > 948) && (t.style.transform = `translate3d(0, ${e}px, 0)`,
        e >= 0 && (s.style.opacity = "" + e / (window.innerHeight / 2)),
        r.style.transform = `translate3d(0, ${e / 10}px, 0)`)
    }
}
customElements.define("image-slideshow", ImageSlideshow),
KROWN.themeName = "Kingdom",
KROWN.themeVersion = "4.3.1",
document.addEventListener("shopify:section:load", i=>{
    window.reorderSections(),
    window.preloadImages(i.target)
}
),
document.addEventListener("shopify:section:unload", i=>{
    window.reorderSections(),
    window.preloadImages(i.target)
}
),
document.addEventListener("shopify:section:reoder", i=>{
    window.reorderSections(),
    window.preloadImages(i.target)
}
);
const executeOnceOnDomContentLoaded = ()=>{
    reframe(document.querySelectorAll('.rte iframe[src*="youtube"], .rte iframe[src*="vimeo"]')),
    document.querySelectorAll("input").forEach(e=>{
        e.addEventListener("change", t=>{
            t.target.value != "" ? t.target.classList.add("filled") : t.target.classList.remove("filled")
        }
        )
    }
    ),
    document.querySelectorAll('input[type="search"]').forEach(e=>{
        e.value = ""
    }
    );
    let i = document.activeElement;
    document.addEventListener("keyup", e=>{
        e.keyCode == window.KEYCODES.TAB && (i.classList.contains("focus") && e.target != i && i.classList.remove("focus"),
        (e.target.classList.contains("regular-select-cover") || e.target.classList.contains("search-field") || e.target.classList.contains("product-item__link") || e.target.classList.contains("content-slider") || e.target.classList.contains("blog-item__header") || e.target.classList.contains("toggle__title") || e.target.tagName == "INPUT") && (i = e.target,
        e.target.classList.add("focus")))
    }
    ),
    window.location.search == "?customer_posted=true" ? setTimeout(()=>{
        window.scroll({
            top: document.querySelector("form .alert").offsetTop - 250,
            behavior: "smooth"
        })
    }
    , 300) : window.location.pathname.includes("/challenge") && setTimeout(()=>{
        window.scroll({
            top: 0,
            behavior: "auto"
        })
    }
    , 300)
}
;
document.readyState !== "loading" ? executeOnceOnDomContentLoaded() : document.addEventListener("DOMContentLoaded", executeOnceOnDomContentLoaded);
//# sourceMappingURL=/s/files/1/0558/3133/0864/t/9/assets/theme.js.map?v=10955347462237448521

//leo code here
function injectGroupIdsForMonster() {
  const cartItems = document.querySelectorAll('.mu-cart-item');

  cartItems.forEach((item) => {
    if (item.querySelector('.group-id')) return;

    const text = item.innerText;
    let groupId = null;

    if (text.includes("XRP Army")) groupId = "xrp_group";
    else if (text.includes("Finishing Preference")) groupId = "xrp_group";
    else if (text.includes("Material Choice")) groupId = "xrp_group";

    if (groupId) {
      const el = document.createElement("div");
      el.className = "group-id";
      el.style.display = "none";
      el.innerText = "Group ID: " + groupId;
      item.appendChild(el);
    }
  });
}

function attachMonsterSyncListeners() {
  const cartItems = document.querySelectorAll('.mu-cart-item');

  cartItems.forEach((item) => {
    const groupIdEl = item.querySelector('.group-id');
    if (!groupIdEl) return;
    const groupId = groupIdEl.innerText.replace("Group ID:", "").trim();

    const plusBtn = item.querySelector('[aria-label*="increase"]');
    const minusBtn = item.querySelector('[aria-label*="decrease"]');
    const qtyDisplay = item.querySelector('.mu-item-quantity .mu-font-bold');

    if (!plusBtn || !minusBtn || !qtyDisplay) return;

    let lastQty = parseInt(qtyDisplay.innerText.trim());

    const observer = new MutationObserver(() => {
      const newQty = parseInt(qtyDisplay.innerText.trim());
      const delta = newQty - lastQty;

      if (delta === 0) return;
      lastQty = newQty;

      document.querySelectorAll('.mu-cart-item').forEach((otherItem) => {
        const otherGroupEl = otherItem.querySelector('.group-id');
        if (!otherGroupEl) return;
        if (!otherGroupEl.innerText.includes(groupId)) return;
        if (otherItem === item) return;

        const otherBtn = delta > 0
          ? otherItem.querySelector('[aria-label*="increase"]')
          : otherItem.querySelector('[aria-label*="decrease"]');

        for (let i = 0; i < Math.abs(delta); i++) {
          if (otherBtn) otherBtn.click();
        }
      });
    });

    observer.observe(qtyDisplay, { childList: true });
  });
}

const globalObs = new MutationObserver(() => {
  injectGroupIdsForMonster();
  attachMonsterSyncListeners();
});
globalObs.observe(document.body, { childList: true, subtree: true });


// assets/theme.js
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('input.sync-qty[data-key]').forEach(input => {
    input.addEventListener('input', () => handleQtyChange(input));
  });
});

async function handleQtyChange(input) {
  const newQty = parseInt(input.value, 10);
  if (isNaN(newQty) || newQty < 0) {
    input.value = input.getAttribute('data-prev') || input.value;
    return;
  }

  const groupId = input.dataset.group || '';
  const targets = groupId
    ? Array.from(document.querySelectorAll(`input.sync-qty[data-group="${groupId}"]`))
    : [ input ];

  // save old quantities
  const original = {};
  targets.forEach(el => original[el.dataset.key] = el.value);

  try {
    // sequentially update each line
    for (let el of targets) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type':'application/json','Accept':'application/json' },
        body: JSON.stringify({ id: el.dataset.key, quantity: newQty })
      }).then(r => { if (!r.ok) throw r; return r.json() });
    }
    // on success, set them all at once
    targets.forEach(el => el.value = newQty);
    window.location.reload();  // re-render totals & item count
  } catch(err) {
    console.error('Cart update failed', err);
    // rollback UI
    targets.forEach(el => el.value = original[el.dataset.key]);
  }
}



























